{
  "topMenu": {
    "dihTitle": "Data Intelligence Hub",
    "dihSubTitle": "Daten sicher in Wert verwandeln",
    "logout": "Abmelden",
    "dihPortal": "DIH-Portal",
    "cofinityDataspace": "Datenraum-Portal",
    "portal": "Portal"
  },
  "userLogoutAlert": {
    "title": "Sind Sie sicher, dass Sie sich abmelden möchten?",
    "back": "Zurück",
    "logout": "Abmelden"
  },
  "languages": {
    "en": "English",
    "de": "German (Deutsch)",
    "es": "Spanish (Español)",
    "fr": "French (Français)",
    "zh": "Chinese (中文/简体)",
    "ja": "Japanese (日本語)"
  },
  "sideMenu": {
    "home": "Startseite",
    "collapse": "Seitenleiste einklappen",
    "help": "Hilfe",
    "prepare": "Daten vorbereiten",
    "model": "Datenmodell",
    "mapping": "Daten-Mapping",
    "converter": "Datenkonverter",
    "provide": "Daten bereitstellen",
    "publishData": "Daten veröffentlichen",
    "assets": "Datensätze",
    "policyPublicationTemplate": "Policy-Vorlage",
    "uploadHistory": "Upload-Verlauf",
    "consume": "Daten beziehen",
    "searchDataOffers": "Datenangebote suchen",
    "simulateDataOffers": "Datenangebote simulieren",
    "negotiatedDataOffers": "Verhandelte Datenangebote",
    "downloadHistory": "Download-Verlauf",
    "govern": "Governance",
    "myPolicies": "Meine Policies",
    "createPolicies": "Policies erstellen",
    "policyTemplate": "Policy-Vorlagen",
    "manageAndConfig": "Verwalten und konfigurieren",
    "connections": "Konnektoren verwalten",
    "jobs": "Logs",
    "monitoring": "Monitoring",
    "licences": "Lizenzen",
    "contractAgreements": "Verträge",
    "providedAgreements": "Bereitgestellte Verträge",
    "incomingAgreements": "Empfangene Verträge",
    "consumedAgreements": "Bezogene Verträge",
    "consumeAutomation": "Automatische Vertragsabschlüsse",
    "networkAnalytics": "Netzwerkanalyse",
    "otherLogs": "Weitere Protokolle",
    "digitalTwin": "Digitale Zwillinge",
    "messagesBrowserInbound": "Eingehende Nachrichten",
    "messagesBrowserOutbound": "Ausgehende Nachrichten",
    "applications": "Anwendungen",
    "electronicControlUnit": "Electronic Control Unit (ECU)",
    "pcfExchange": "Product Carbon Footprint (Jupiter)",
    "pcfExchangeV9": "Product Carbon Footprint (Saturn)",
    "pcfRequests": "PCF-Anfragen",
    "pcfExchangeHistory": "PCF-Austauschverlauf (Jupiter)",
    "pcfExchangeV9History": "PCF-Austauschverlauf (Saturn)",
    "publicationTemplates": "Veröffentlichungsvorlagen",
    "certificateManagement": "Company Certificate Management",
    "certificates": "Zertifikate",
    "connectors": "Meine Konnektoren",
    "contractDefinitions": "Vertragsdefinitionen"
  },
  "workspace": {
    "rail": {
      "label": "Hauptnavigation",
      "home": "Start",
      "apps": "Apps",
      "advanced": "Erweitert",
      "help": "Hilfe"
    },
    "apps": {
      "title": "Aktuell in",
      "none": "Kein Arbeitsbereich ausgewählt",
      "search": "Suchen",
      "close": "Schließen",
      "comingSoon": "Demnächst verfügbar",
      "noResults": "Keine passenden Apps gefunden.",
      "names": {
        "certificateManagement": "Zertifikatsverwaltung",
        "pcfJupiter": "Product Carbon Footprint Jupiter",
        "pcfSaturn": "Product Carbon Footprint Saturn",
        "blockNotifications": "Sperrbenachrichtigungen",
        "traceability": "Rückverfolgbarkeit",
        "cyberSecurityMetrics": "Cybersicherheits-Metriken",
        "electronicControlUnit": "Elektronisches Steuergerät",
        "batteryPassport": "Batteriepass",
        "simpleFileExchange": "Einfacher Dateiaustausch",
        "advanced": "Erweitert"
      }
    },
    "menu": {
      "groups": {
        "pcfRequestsResponses": "PCF-Anfragen und -Antworten",
        "overview": "Übersicht",
        "provide": "Bereitstellen",
        "consume": "Beziehen",
        "history": "Verlauf",
        "notifications": "Benachrichtigungen",
        "diagnostics": "Diagnose",
        "pcfRequests": "PCF-Anfragen",
        "pcfCalculation": "PCF-Berechnung",
        "ecuMessages": "ECU-Nachrichten",
        "governance": "Governance",
        "data": "Daten",
        "connections": "Verbindungen",
        "operationsDiagnostics": "Betrieb und Diagnose",
        "digitalTwins": "Digitale Zwillinge"
      },
      "items": {
        "pcfProvider": "PCF-Anbieter",
        "pcfConsume": "PCF-Verbrauch",
        "dashboard": "Dashboard",
        "userGuide": "Benutzerhandbuch und Tutorials",
        "developerDocumentation": "Entwicklerdokumentation",
        "publishCertificate": "Zertifikat veröffentlichen",
        "myCertificates": "Meine Zertifikate",
        "sharedCertificates": "Geteilte Zertifikate",
        "mySites": "Meine Standorte",
        "discoverCertificates": "Zertifikate entdecken",
        "downloadCertificates": "Zertifikate herunterladen",
        "consumptionHistory": "Bezugsverlauf",
        "messagesLog": "Nachrichtenprotokoll",
        "createPcfOffer": "PCF-Angebot erstellen",
        "discoverPcf": "PCF-Daten entdecken und anfragen",
        "pcfAspects": "PCF-Aspekte",
        "pcfDataRequests": "PCF-Datenanfragen",
        "pcfExchangeHistory": "PCF-Austauschverlauf",
        "pcfCalculator": "PCF-Rechner",
        "sendBlockNotifications": "Sperrbenachrichtigungen senden",
        "receivedBlockNotifications": "Empfangene Sperrbenachrichtigungen",
        "sentNotificationsHistory": "Verlauf gesendeter Benachrichtigungen",
        "receivedNotificationsHistory": "Verlauf empfangener Benachrichtigungen",
        "createTraceabilityOffer": "Rückverfolgbarkeitsangebot erstellen",
        "createQualityAlert": "Qualitätsmeldung oder Untersuchung erstellen",
        "discoverTraceability": "Rückverfolgbarkeitsdaten entdecken",
        "industryCoreNotifications": "Industry-Core-Benachrichtigungen",
        "traceabilityNotifications": "Rückverfolgbarkeits-Benachrichtigungen",
        "exchangeHistory": "Austauschverlauf",
        "contractAgreements": "Vertragsvereinbarungen",
        "createSendMetrics": "Metriken erstellen und senden",
        "receiveViewMetrics": "Metriken empfangen und anzeigen",
        "ecuAssets": "ECU-Assets",
        "outgoingMessages": "Ausgehende Nachrichten",
        "incomingMessages": "Eingehende Nachrichten",
        "processLogs": "Prozessprotokolle",
        "apiPollingLogs": "API-Polling-Protokolle",
        "myPolicies": "Meine Richtlinien",
        "myContractAgreements": "Meine Vertragsvereinbarungen",
        "myContractDefinitions": "Meine Vertragsdefinitionen",
        "myAssets": "Meine Assets",
        "simulateDataOffers": "Datenangebote simulieren",
        "myConnectors": "Meine Konnektoren",
        "externalConnectionManagement": "Externes Verbindungsmanagement",
        "twinBrowserProvider": "Twin-Browser – Anbieter",
        "twinBrowserConsumer": "Twin-Browser – Verbraucher",
        "switchApplication": "Anwendung wechseln"
      }
    }
  },
  "versionModal": {
    "title": "Allgemeine Informationen",
    "error": "Fehler beim Abrufen von Versionsdetails",
    "table": {
      "title": "Details zur Komponente",
      "componentName": "Name der Komponente",
      "imageVersion": "Software-Image-Version",
      "chartVersion": "Helm-Chart-Version"
    }
  },
  "dropdown": {
    "selectAll": "Alles auswählen",
    "noOption": "Keine Optionen verfügbar",
    "noSuchOption": "Keine passende Option gefunden",
    "selectConnection": "Eine Verbindung auswählen"
  },
  "certificateManagement": {
    "title": "Business Partner Certificate Management",
    "description": "Willkommen bei der benutzerfreundlichen End-to-End-Lösung für den Austausch von Unternehmenszertifikaten mit Ihren Geschäftspartnern in Catena-X.",
    "howTo": {
      "description": "Durchsuchen Sie den Datenangebotskatalog anderer Catena-X-Teilnehmer. Sie können Zertifikatsangebote suchen, auswählen und beziehen. Die Suche ist auch über den Firmennamen möglich.",
      "doc": "Möchten Sie mehr darüber erfahren, wie die Zertifikatsverwaltung funktioniert? "
    },
    "landingTiles": {
      "tile_1": {
        "title": "Zertifikat veröffentlichen",
        "description": "Erstellen und teilen Sie Ihre Zertifikate im Catena-X-Netzwerk."
      },
      "tile_2": {
        "title": "Zertifikate finden und abrufen",
        "description": "Zertifikate Ihrer Geschäftspartner einfach suchen und herunterladen."
      },
      "tile_3": {
        "title": "Veröffentlichte Zertifikate",
        "description": "Übersicht aller von Ihnen bereitgestellten Zertifikate"
      },
      "tile_4": {
        "title": "Empfangene Zertifikate",
        "description": "Übersicht aller Zertifikate, die Sie von Partnern erhalten haben"
      },
      "tile_5": {
        "title": "Eingehende Zertifikatsanfragen",
        "description": "Übersicht der eingehenden Anfragen zum Teilen von Zertifikaten"
      },
      "tile_6": {
        "title": "Status ausgehender Zertifikate",
        "description": "Übersicht über den Status Ihrer geteilten Zertifikate"
      },
      "tile_7": {
        "title": "Zertifikate anfordern",
        "description": "Zertifikate gezielt bei Ihren Geschäftspartnern anfordern."
      }
    },
    "recentCertificateRequests": "Aktuelle Zertifikatsanfragen",
    "learnMore": "Erfahren Sie mehr über die Zertifikatsverwaltung",
    "requestCertificates": "Zertifikate anfordern",
    "pushCertificate": "Zertifikat aktiv teilen (PUSH)",
    "pushDescription": "Das bestehende Zertifikat wird mit dem unten ausgewählten Partner geteilt. Es gelten dieselben Policies wie im ursprünglichen Angebot. Wenn Sie die Policies ändern möchten, erstellen Sie bitte ein neues Datenangebot.",
    "pushSuccess": "Das Zertifikat wird geteilt. Prozess-ID: {id}",
    "receiverBpn": "Empfänger-BPN",
    "providerBpn": "Partner-BPN",
    "locationBpns": "Standort (BPNS/BPNA)",
    "certificateType": "Zertifikatstyp",
    "requestSuccess": "Zertifikatsanfrage erfolgreich übermittelt.",
    "pushResult": "{successful} von {total} {status} Anfragen erfolgreich",
    "receiveConfirmTitle": "Zertifikatsempfang bestätigen",
    "receiveConfirmDesc": "Mit Klick auf Ja bestätigen Sie, dass Sie das vom Partner geteilte Zertifikat erhalten haben. Der Anbieter wird über Ihre Bestätigung informiert. Anschließend können Sie das Zertifikat annehmen oder ablehnen.",
    "acceptedConfirmTitle": "Zertifikat annehmen",
    "acceptedConfirmDesc": "Mit Klick auf Ja bestätigen Sie, dass das Zertifikat Ihren Erwartungen entspricht. Über das Ansichtssymbol können Sie das Zertifikat als PDF herunterladen.",
    "rejectedConfirmTitle": "Zertifikat ablehnen",
    "rejectedConfirmDesc": "Mit Klick auf Ja lehnen Sie das eingehende Zertifikat ab. Der Anbieter wird über die Ablehnung informiert. Er kann das Zertifikat erneut teilen oder Sie können ein neues Zertifikat anfordern.",
    "processStarted": "Prozess '{type}' gestartet. Prozess-ID: {id}",
    "certificateDetails": "Zertifikatsdetails",
    "availableCertificate": "Zertifikat als verfügbar melden",
    "updateSuccess": "Zertifikat erfolgreich aktualisiert.",
    "updateFailure": "Aktualisierung des Zertifikats fehlgeschlagen.",
    "wizard": {
      "selectCompanies": "Unternehmen auswählen",
      "selectPolicies": "Policies auswählen"
    },
    "step1Description": "Wählen Sie ein oder mehrere Unternehmen aus, mit denen Sie das Zertifikat teilen möchten.",
    "step2Description": "Wählen Sie die Policies für die Freigabe des Zertifikats aus.",
    "noPoliciesFound": "Für die ausgewählten Unternehmen wurden keine Policies gefunden.",
    "policiesFound": "{count} Policies gefunden",
    "selectedPolicies": "{count} ausgewählt",
    "policyName": "Name der Policy",
    "bpn": "BPN",
    "policyType": "Typ",
    "errorFetchingPolicies": "Policies konnten nicht abgerufen werden.",
    "assetId": "Asset-ID",
    "noPoliciesFoundInCatalog": "Für die ausgewählten Unternehmen wurden im Katalog keine Policies gefunden.",
    "duplicateBpnError": "Sie können dieselbe BPN nicht zweimal auswählen.",
    "membershipValue": "Mitgliedschaft",
    "contractReference": "Vertragsreferenz",
    "connectorEndpoint": "Konnektor-Endpunkt",
    "noCompatibleOfferPush": "Kein für das aktive Teilen von Zertifikaten geeignetes Datenangebot gefunden. Bitten Sie die ausgewählten Geschäftspartner, ein entsprechendes Angebot zu veröffentlichen.",
    "noCompatibleOfferAvailable": "Kein geeignetes Zertifikatsangebot gefunden. Bitten Sie die ausgewählten Geschäftspartner, ein entsprechendes Angebot zu veröffentlichen.",
    "connectorUrl": "Konnektor-URL (optional)",
    "connectorUrlOptional": "Einen bestimmten Konnektor auswählen (optional)",
    "connectorUrlNone": "Kein bestimmter Konnektor (alle durchsuchen)",
    "connectorUrlNote": "Für dieses Unternehmen wurde kein Konnektor gefunden",
    "certificateDownload": {
      "downloadReceivedJson": "Empfangenes JSON herunterladen",
      "downloadCertificatePdf": "Zertifikat als PDF herunterladen"
    }
  },
  "schemas": {
    "businessPartnerCertificate": {
      "groups": {
        "basicInfo": "Grundlegende Zertifikatsinformationen",
        "issuer": "Herausgeberinformationen",
        "validity": "Gültigkeitszeitraum",
        "trust": "Vertrauensinformationen",
        "validator": "Prüforganisation",
        "application": "Anwendungsbereich",
        "enclosedSites": "Eingeschlossene Standorte"
      },
      "fields": {
        "businessPartnerNumber": "Geschäftspartnernummer",
        "registrationNumber": "Registrierungsnummer",
        "certificateType": "Zertifikatstyp",
        "certificateVersion": "Zertifikatsversion",
        "issuerName": "Name des Herausgebers",
        "issuerBpn": "Herausgeber-BPN",
        "validFrom": "Gültig ab",
        "validUntil": "Gültig bis",
        "trustLevel": "Vertrauensstufe",
        "uploaderBpn": "BPN des Bereitstellers",
        "validatorBpn": "BPN der Prüforganisation",
        "validatorName": "Name der Prüforganisation",
        "areaOfApplication": "Anwendungsbereich",
        "siteBpn": "Standort-BPN",
        "siteAreaOfApplication": "Standort-Anwendungsbereich"
      },
      "tooltips": {
        "basicInfo": "Ein Geschäftspartnerzertifikat beschreibt ein Zertifikat (z. B. ISO 9001, IATF 16949) eines Catena-X-Geschäftspartners.",
        "businessPartnerNumber": "Die Geschäftspartnernummer (BPN) der zertifizierten Rechtseinheit, auf die das Zertifikat ausgestellt ist.",
        "registrationNumber": "Registrierungsnummer des Zertifikats, wie auf dem Zertifikat angegeben.",
        "certificateType": "Art des Zertifikats, wie im Dokument angegeben. Gültige Typen sind zentral in Catena-X registriert.",
        "certificateVersion": "Version des Zertifikats, wie im Dokument angegeben, in der Regel die Version des zugrunde liegenden Zertifizierungsstandards.",
        "issuerName": "Name des Ausstellers, d. h. der Zertifizierungsstelle.",
        "issuerBpn": "Die Geschäftspartnernummer (BPN) des Ausstellers.",
        "validFrom": "Beginn der Gültigkeit, wie auf dem Zertifikat angegeben.",
        "validUntil": "Ende der Gültigkeit, wie auf dem Zertifikat angegeben. Läuft das Zertifikat nie ab, sollte der Wert 9999-12-31 lauten.",
        "trustLevel": "Die Vertrauensstufe des Zertifikats: none, low, high oder trusted",
        "uploaderBpn": "Die Geschäftspartnernummer (BPN) des Geschäftspartners, der die Zertifikatsdaten oder das Dokument ursprünglich bereitgestellt hat.",
        "validatorBpn": "Die Geschäftspartnernummer (BPN) des Dienstleisters, der das Zertifikat geprüft hat.",
        "validatorName": "Optionaler Name des Dienstleisters, der das Zertifikat geprüft hat.",
        "areaOfApplication": "Angaben dazu, für welche Bereiche oder Anwendungen das Zertifikat für ein Unternehmen und/oder einen Standort gilt.",
        "siteBpn": "Die Geschäftspartnernummer (BPNS oder BPNA) eines eingeschlossenen Standorts.",
        "siteAreaOfApplication": "Angaben dazu, für welche Bereiche oder Anwendungen das Zertifikat an diesem Standort gilt."
      }
    }
  },
  "common": {
    "start": "Start",
    "firstName": "Vorname",
    "lastName": "Nachname",
    "email": "E-Mail-Adresse",
    "phoneNumber": "Telefonnummer",
    "contactPerson": "Ansprechpartner",
    "welcome": "Willkommen",
    "street": "Straße",
    "city": "Stadt",
    "country": "Land",
    "postCode": "Postleitzahl",
    "number": "Anzahl",
    "next": "Weiter",
    "prev": "Zurück",
    "alreadyAccount": "Haben Sie bereits ein Konto?",
    "login": "Anmelden",
    "loginNow": "Jetzt anmelden",
    "register": "Registrieren",
    "home": "Startseite",
    "submit": "Senden",
    "attention": "Achtung",
    "desc": "Beschreibung",
    "website": "Webseite",
    "contact": "Kontakt",
    "details": "Details",
    "plan": "Tarif",
    "table": "Tabelle",
    "grid": "Kachelansicht",
    "listView": "Listenansicht",
    "gridView": "Kachelansicht",
    "firstPage": "Zur ersten Seite",
    "previousPage": "Zur vorherigen Seite",
    "nextPage": "Zur nächsten Seite",
    "lastPage": "Zur letzten Seite",
    "paginationUnknownButton": "Fehler in der Seitennavigation",
    "download": "Herunterladen",
    "delete": "Löschen",
    "edit": "Bearbeiten",
    "information": "Informationen",
    "organization": "Organisation",
    "cancel": "Abbrechen",
    "save": "Speichern",
    "upload": "Hochladen",
    "link": "Link",
    "view": "Ansehen",
    "search": "Suche",
    "selectOption": "Wählen Sie eine Option",
    "sortBy": "Sortieren nach",
    "dataspace": "Datenraum",
    "select": "Auswählen",
    "date": "Datum",
    "title": "Titel",
    "back": "Zurück",
    "startTyping": "Beginnen Sie mit der Eingabe",
    "useCases": "Use Cases",
    "done": "Fertig",
    "enterValue": "Geben Sie einen Wert ein",
    "selectValue": "Wählen Sie einen Wert aus",
    "selectDate": "Wählen Sie ein Datum",
    "selectYear": "Jahr auswählen",
    "refresh": "Aktualisieren",
    "provided": "Bereitgestellt",
    "consumed": "Bezogen",
    "searchByName": "Suche nach Namen",
    "close": "Schließen",
    "copyToClipboard": "In die Zwischenablage kopiert!",
    "enterKeyName": "Bezeichnung eingeben",
    "fileDownloadSuccess": "Datei erfolgreich heruntergeladen",
    "fileDownloadError": "Dateidownload fehlgeschlagen",
    "certificate": "Zertifikat",
    "manageConnections": "Konnektoren verwalten",
    "confirm": "Bestätigen",
    "yes": "Ja",
    "no": "Nein",
    "connectionDetails": "Verbindungsdetails ({type})",
    "hide": "Ausblenden",
    "unpublish": "Veröffentlichung zurückziehen",
    "severity": "Schweregrad",
    "expectedResponseBy": "Erwartete Reaktion bis",
    "clear": "Zurücksetzen",
    "viewAll": "Alle anzeigen",
    "apply": "Anwenden",
    "from": "Von",
    "to": "Bis",
    "isRequired": "ist erforderlich",
    "confirmationRequired": "Bitte bestätigen Sie, indem Sie das Kästchen ankreuzen",
    "send": "Senden",
    "update": "Aktualisieren",
    "createSend": "Erstellen und senden",
    "share": "Teilen",
    "recentRequests": "Neue Anfragen",
    "active": "Aktiv",
    "viewDocs": "Dokumentation anzeigen",
    "request": "Anfordern",
    "noData": "Keine Daten",
    "autosaving": "Wird automatisch gespeichert",
    "connectIntegrate": "Connect & Integrate"
  },
  "genericError": "Da ist leider etwas schiefgelaufen. Bitte versuchen Sie es erneut.",
  "validation": {
    "fieldRequired": "{field} ist erforderlich.",
    "fieldNumeric": "Das Feld {field} darf nur Zahlen enthalten.",
    "fieldAlpha": "Das Feld {field} darf nur Buchstaben sowie die Zeichen _ und - enthalten.",
    "fieldAlphanumeric": "Das Feld {field} darf nur Buchstaben, Zahlen sowie die Zeichen _ und - enthalten.",
    "fieldNumericDash": "Das Feld {field} darf nur Zahlen und das Zeichen - enthalten.",
    "fieldHouseNumber": "Das Feld {field} darf nur Zahlen, Buchstaben sowie die Zeichen - und / enthalten.",
    "fieldPhoneNumber": "Das Feld {field} darf nur Zahlen und das Zeichen - enthalten und muss mit + oder 00 beginnen.",
    "fieldAlphaDash": "Das Feld {field} darf nur Buchstaben und das Zeichen - enthalten.",
    "exceptHTMLTagBrackets": "Das Feld {field} darf die folgenden Zeichen nicht enthalten: ^<>",
    "isMaxLength": "überschreitet die maximale Länge von 10 Zeichen.",
    "emailFormat": "Die E-Mail-Adresse hat ein ungültiges Format",
    "fileSizeError": "Die Datei ist größer als {size} MB.",
    "csvFileSizeError": "Diese Datei ist zu groß. Sie können Dateien bis zu {size} MB hochladen.",
    "csvFileExtensionError": "Es sind nur Dateien mit der Endung .csv erlaubt.",
    "csvFileIsEmptyError": "Die Datei ist leer. Sie muss mindestens {size} KB groß sein.",
    "csvFileFormatError": "Die Datei stimmt nicht mit dem erwarteten Format überein. Bitte verwenden Sie die bereitgestellte Vorlage und versuchen Sie es erneut.",
    "uploadFails": "Upload fehlgeschlagen",
    "fileExtensionError": "Dieser Dateityp wird nicht unterstützt",
    "fileIsMalwareInfectedError": "Diese Datei enthält möglicherweise Schadsoftware. Aus Sicherheitsgründen kann sie nicht hochgeladen werden. Bitte prüfen Sie die Datei.",
    "customValidation": "Das Feld {field} hat das falsche Format.",
    "selectCountryFirst": "Bitte wählen Sie zuerst ein Land aus",
    "validationPostCodeCaseDE": "Das Feld hat das falsche Format. Es muss 5 Ziffern enthalten, z. B. 53113.",
    "validationAlphanumericCase": "Das Feld darf nur Buchstaben, Zahlen, Bindestriche und Unterstriche enthalten und muss mit einem Buchstaben oder einer Zahl beginnen.",
    "validationNumericDashCase": "Das Feld darf nur Zahlen und das Zeichen - enthalten.",
    "url": "Bitte geben Sie eine gültige URL ein",
    "required": "Dieses Feld ist erforderlich",
    "password": {
      "passwordStrength": "Stärke des Passworts",
      "weak": "Schwach",
      "average": "Mittel",
      "strong": "Stark",
      "passwordValidationMoreChar": "{count} oder mehr Zeichen",
      "passwordUpperAndLowerChar": "Groß- und Kleinbuchstaben",
      "passwordAtLeastNumber": "Mindestens eine Zahl",
      "passwordAtLeastSpecialChar": "Mindestens ein Sonderzeichen (außer <>&\"'[])",
      "passwordDiffFromPrev": "Unterscheidet sich von Ihren bisherigen Passwörtern"
    }
  },
  "footer": {
    "tagLine": "Let's power higher performance",
    "imprint": "Impressum",
    "imprintShort": "Impressum",
    "certifications": "Zertifizierungen",
    "imprintLink": "https://dih.telekom.com/de/impressum",
    "contact": "Kontakt",
    "contactLink": "https://dih.telekom.com/de/kontakt",
    "termsAndConditions": "Allgemeine Geschäftsbedingungen",
    "privacy": "Datenschutzerklärung",
    "privacyShort": "Datenschutzerklärung",
    "telekom": "T-Systems International GmbH. Alle Rechte vorbehalten.",
    "telekomShort": "T-Systems International GmbH",
    "note": "Telekom Data Intelligence Hub. Nur für Geschäftskunden.",
    "brandedNote": "Unterstützt durch den Telekom Data Intelligence Hub",
    "cookieSettings": "Cookie-Einstellungen",
    "cookieSettingsShort": "Cookies",
    "life": "Erleben, was verbindet."
  },
  "cookieSettings": {
    "collapsedTitle": "Datenschutz-Einstellungen",
    "collapsedText": "Diese Website verwendet Cookies und ähnliche Technologien. Dabei handelt es sich um kleine Textdateien, die auf Ihrem Computer gespeichert und gelesen werden. Indem Sie auf '{0}' klicken, akzeptieren Sie die Verarbeitung, die Erstellung individueller Nutzungsprofile über Websites und Partner hinweg sowie die Übermittlung Ihrer Daten an Dritte, die Ihre Daten teilweise in Ländern außerhalb der Europäischen Union verarbeiten (Art. 49 DSGVO). Einzelheiten finden Sie in Abschnitt 2 der {1}. Die Daten werden für Analysen, Retargeting und für die Ausspielung von personalisierten Inhalten und Werbung auf Telekom-Seiten und Websites Dritter verwendet. Weitere Informationen, u.a. Informationen zur Datenverarbeitung durch Drittanbieter und die Möglichkeit des Widerrufs, finden Sie in den Einstellungen und in unseren Datenschutzhinweisen. Hier können Sie nur mit den notwendigen Werkzeugen {2}.",
    "extendedTitle": "Datenschutz-Einstellungen",
    "extendedText": "Um Ihnen ein optimales Website-Erlebnis zu bieten, verwenden wir Cookies. Dazu gehören Cookies für den Betrieb und die Optimierung der Seite sowie für Dienste wie Text- oder Videochat und für Werbung auf Basis Ihres Online-Nutzungsverhaltens. So können wir z.B. erkennen, ob Sie unsere Seiten wiederholt von demselben Gerät aus besuchen. Wir möchten Ihnen die Wahl lassen, welche Cookies Sie zulassen:",
    "policyLinkHref": "https://dih.telekom.com/de/datenschutz",
    "policyLinkCookieHref": "https://dih.telekom.com/de/datenschutz",
    "policyLinkTextShort": "Datenschutzinformationen",
    "policyLinkText": "Datenschutzinformationen",
    "rejectLinkText": "fortfahren",
    "acceptButton": "Alle akzeptieren",
    "saveButton": "Einstellungen speichern",
    "settingsButton": "Einstellungen ändern",
    "showMore": "Mehr anzeigen",
    "showLess": "Weniger anzeigen",
    "categoryTitleEssential": "Erforderliche Cookies",
    "categoryTitleAnalytics": "Analytische Cookies",
    "categoryTitleMarketing": "Marketing-Cookies",
    "categoryTitleThirdParty": "Dienstleistungen anderer Unternehmen (unabhängige Drittanbieter)",
    "categoryTextEssential": "Diese Cookies sind erforderlich, um Ihnen die Navigation durch die Websites und die Nutzung wichtiger Funktionen zu ermöglichen. Sie unterstützen grundlegende Funktionen, wie z.B. die Bestellabwicklung im Online-Shop und den Zugriff auf gesicherte Bereiche der Webseite. Sie dienen auch dem Zweck, eine anonymisierte Analyse des Nutzerverhaltens durchzuführen, mit der wir unsere Webseiten für Sie fortlaufend weiterentwickeln und verbessern.",
    "categoryTextAnalytics": "Diese Cookies helfen uns, das Nutzerverhalten besser zu verstehen. Analyse-Cookies ermöglichen die Zusammenstellung von Nutzungs- und Identifikationsdaten durch den Originalanbieter oder Drittanbieter zu pseudonymen Nutzungsprofilen. Wir verwenden Analyse-Cookies z.B., um die Anzahl der einzelnen Besucher einer Webseite oder eines Dienstes zu ermitteln, statistische Daten über die Leistung unserer Produkte zu sammeln und das Nutzungsverhalten und die Besucherinteraktionen der Besucher auf der Grundlage anonymer und pseudonymer Informationen zu analysieren. Diese Informationen können nicht auf eine Person zurückgeführt werden.",
    "categoryTextMarketing": "Diese Cookies und ähnliche Technologien werden verwendet, um die Anzeige personalisierter und damit relevanter Marketinginhalte zu ermöglichen. Marketing-Cookies werden verwendet, um interessante Werbeinhalte anzuzeigen und die Wirksamkeit unserer Kampagnen zu messen. Dies geschieht nicht nur auf den Webseiten der Telekom, sondern auch auf anderen Seiten der Werbepartner (Drittanbieter). Dies wird auch als Retargeting bezeichnet. Sie wird verwendet, um pseudonyme Inhalte oder Anzeigenprofile zu erstellen, relevante Werbung auf anderen Websites zu schalten und um Erkenntnisse über Zielgruppen abzuleiten, die sich die Anzeigen und Inhalte angesehen haben. Diese Informationen können nicht auf eine Person zurückgeführt werden. Marketing- und Retargeting-Tools unterstützen uns dabei, Ihnen Werbeinhalte zu liefern, die möglicherweise für Sie relevant sind. Durch die Unterdrückung von Marketing-Cookies sehen Sie immer noch die gleiche Menge an Werbung, die jedoch für Sie möglicherweise weniger relevant ist.",
    "categoryTextThirdParty": "Die Webseiten der Telekom enthalten Links zu Drittanbietern, die ihre Dienste in eigener Verantwortung erbringen. Wenn Sie die Webseiten der Telekom besuchen, erfassen Cookies oder ähnliche Technologien Daten und senden sie an Dritte, zum Teil für eigene Zwecke der Telekom. Umfang, Zweck und Rechtsgrundlage für die weitere Verarbeitung zu eigenen Zwecken des Dritten entnehmen Sie bitte den Datenschutzhinweisen des Drittanbieters. Informationen zu den unabhängigen Drittanbietern finden Sie in den Datenschutzhinweisen."
  },
  "messages": {
    "noDataAvailable": "Keine Daten verfügbar",
    "noMatchFound": "Keine Übereinstimmung gefunden",
    "maximumFileSize": "Maximale Dateigröße",
    "suitableFileFormats": "Geeignete Dateiformate",
    "loading": "Wird geladen...",
    "dragDropText": "oder per Drag & Drop hier ablegen",
    "noConnectors": "Keine Konnektoren gefunden",
    "comingSoon": "Demnächst verfügbar"
  },
  "pageNotFound": {
    "title": "Hoppla! Die gesuchte Seite konnte nicht gefunden werden.",
    "subtitle": "Schauen Sie sich in der Zwischenzeit gern unsere weiteren Ressourcen an."
  },
  "helpResources": {
    "needHelp": "Sie brauchen Hilfe bei der Wahl des passenden Tarifs, weitere Informationen oder haben technische Fragen?",
    "needHelpShorter": "Benötigen Sie weitere Hilfe?",
    "developerDoc": "API-Dokumentation",
    "developerDocDesc": "API-Dokumentation zur Automatisierung Ihres Datenaustauschs",
    "example": "Beispiel",
    "examples": "Dokumentation",
    "tutorials": "Anleitungen",
    "exampleDescription": "Finden Sie Use Cases und Demos",
    "FAQ": "Häufig gestellte Fragen",
    "FAQDescription": "Antworten auf häufige Fragen, von der Abrechnung bis zum Datenschutz",
    "browse": "Durchsuchen",
    "demos": "Demos",
    "demosDescription": "Finden Sie Use Cases und Demos, die für Ihre Branche relevant sind",
    "glossary": "Glossar",
    "glossaryDescription": "Begriffe und Definitionen rund um den Data Intelligence Hub, IDSA, Catena-X, Gaia-X und mehr.",
    "glossaryDescriptionShorter": "Finden Sie Begriffe und Definitionen zu Catena-X, Gaia-X und mehr",
    "customerSupport": "Support",
    "customerSupportDesc": "Nicht gefunden, wonach Sie suchen?",
    "contactUs": "Diese Funktion ist in Ihrem aktuellen Tarif nicht enthalten. Bitte kontaktieren Sie uns für ein Upgrade.",
    "contactUsBtn": "Kontakt aufnehmen"
  },
  "basicInfo": {
    "title": "Details",
    "dataspace": "Datenraum",
    "bpn": "Geschäftspartnernummer (BPN)"
  },
  "feedbackCard": {
    "title": "Benötigen Sie weitere Hilfe?",
    "contactUs": "Kontakt aufnehmen"
  },
  "error": {
    "pageNotFound": "Seite nicht gefunden (404)",
    "somethingWrong": "Etwas ist schiefgelaufen.",
    "propertyNotFound": "Eigenschaft nicht gefunden",
    "uniquePropertyName": "Der Name der Eigenschaft muss eindeutig sein",
    "dctTypeNotFound": "dct:type nicht gefunden"
  },
  "helpWidget": {
    "askSupport": "Support kontaktieren",
    "chatboxTitle": "Hilfe-Chat",
    "chatboxSubtitle": "Support des Telekom Data Intelligence Hub",
    "defaultMessage": {
      "body": "Hallo, willkommen im Support-Kanal des Telekom Data Intelligence Hub. Bitte wählen Sie unten eine Option aus."
    },
    "whatCanWeHelpWith": "Womit können wir Ihnen heute helfen?",
    "suggestedAnswers": {
      "knowledgeBase": "Wissensdatenbank, Dokumentation und FAQs",
      "contactSupport": "Support kontaktieren",
      "contactSales": "Vertrieb kontaktieren"
    }
  },
  "pcfExchange": {
    "title": "PCF-Datenaustausch",
    "description": "Willkommen bei der einfach zu bedienenden End-to-End-Lösung für den Austausch von Product-Carbon-Footprint-Daten (PCF) in Catena-X.",
    "recentRequests": "Aktuelle PCF-Anfragen",
    "viewAllRequests": "Alle Anfragen anzeigen",
    "requestPcf": "PCF-Anfrage senden",
    "termCheck": "Mit dem Absenden der Anfrage verstehe ich, dass der Vertrag über das Datenangebot gemäß den vom Datenanbieter festgelegten Policies ausgehandelt wird.",
    "pcfSuccess": "PCF-Anfrage erfolgreich gesendet.",
    "landing": {
      "pcfTitle": "PCF-Datenangebot erstellen",
      "pcfDesc": "Stellen Sie Ihre PCF-Daten bereit und teilen Sie sie mit Partnern im Catena-X-Netzwerk.",
      "discoverTitle": "PCF-Daten finden und anfragen",
      "discoverDesc": "Suchen Sie PCF-Daten im Catena-X-Netzwerk oder fragen Sie sie in wenigen Schritten bei Ihren Partnern an.",
      "pcfReqTitle": "PCF-Anfragen",
      "pcfReqDesc": "Bearbeiten Sie die PCF-Anfragen Ihrer Partner im Catena-X-Netzwerk.",
      "pcfCalcTitle": "PCF-Berechnung",
      "pcfCalcDesc": "Berechnen Sie PCF-Werte und übernehmen Sie sie direkt in Ihre Anwendungen oder in den PCF-Datenaustausch.",
      "pcfHistoryTitle": "PCF-Austauschverlauf",
      "pcfHistoryDesc": "Behalten Sie den Überblick über Ihren PCF-Datenaustausch im Catena-X-Netzwerk und mit Ihren Partnern.",
      "documentation": "Erfahren Sie mehr über den PCF-Datenaustausch",
      "howTo": {
        "description": "Stellen Sie PCF-Daten bereit, finden Sie PCF-Daten Ihrer Partner und verwalten Sie PCF-Anfragen. Alles standardkonform über Catena-X.",
        "doc": "Möchten Sie mehr über Connect & Integrate erfahren? Hier geht es zur Dokumentation: "
      }
    },
    "requests": {
      "pcfRequests": "PCF-Anfragen",
      "reqDesc": "In diesem Bereich verwalten Sie die PCF-Anfragen Ihrer Partner.",
      "productId": "Produkt-ID*",
      "bpn": "BPN*",
      "message": "Nachricht",
      "howTo": {
        "title": "Möchten Sie mehr über die Bearbeitung von PCF-Anfragen erfahren?",
        "description": "In diesem Bereich können Sie PCF-Anfragen Ihrer Partner genehmigen oder ablehnen. Außerdem sehen Sie den Status des PCF-Datenaustauschs und behalten den Überblick über Ihre PCF-Datenkette.",
        "doc": "Möchten Sie mehr darüber erfahren, wie Datenangebote, Vertragsverhandlung und Datenbezug funktionieren?"
      }
    },
    "responses": {
      "howTo": {
        "description": "Durchsuchen Sie den Datenangebotskatalog anderer Catena-X-Teilnehmer. Sie können ein Datenangebot suchen, auswählen und beziehen. Die Suche ist über den Firmennamen, die Hersteller-Teilenummer oder eine Kombination aus beidem möglich."
      }
    },
    "view": {
      "title": "PCF-Details anzeigen"
    }
  },
  "pcfExchangeV9": {
    "landing": {
      "pcfReqTitle": "PCF-Daten bereitstellen",
      "pcfHistoryTitle": "PCF-Daten anfragen"
    },
    "aspects": {
      "title": "Bereitgestellte PCF-Werte",
      "description": "Übersicht aller PCF-Werte, die Sie bereitgestellt haben.",
      "cardDescription": "Prüfen Sie Ihre bereitgestellten PCF-Werte, bevor sie mit Partnern ausgetauscht werden.",
      "responses": "Rückmeldungen",
      "assets": "Datensätze"
    },
    "incomingRequests": "Eingehende PCF-Anfragen",
    "sentResponses": "Gesendete PCF-Rückmeldungen",
    "sentRequests": "Gesendete PCF-Anfragen",
    "incomingResponses": "Eingehende PCF-Rückmeldungen",
    "requests": {
      "pcfRequests": "PCF-Daten bereitstellen",
      "partIdDescription": "Geben Sie die Hersteller-Teilenummer oder die Kunden-Teilenummer an. Mindestens eine davon ist erforderlich.",
      "manufacturerPartId": "Hersteller-Teilenummer",
      "customerPartId": "Kunden-Teilenummer",
      "eitherPartIdRequired": "Es ist entweder die Hersteller-Teilenummer oder die Kunden-Teilenummer erforderlich."
    }
  },
  "cyberSecurityKPIs": {
    "title": "Cyber Security Metrics",
    "historyTitle": "Gesendete Cyber Security Metrics",
    "historySubTitle": "Hier sehen Sie Ihre geteilten Daten",
    "description": "Willkommen beim Austausch Ihrer Cybersecurity-Kennzahlen mit Ihrem OEM",
    "nothinghere": "Hier ist noch nichts.",
    "newEntryAppearance": "Sobald Sie einen neuen Eintrag erstellen, erscheint er hier.",
    "createKPITitle": "Cyber Security Metrics erfassen und senden",
    "createKPISubTitle": "Bitte füllen Sie alle Angaben in einem Durchgang aus. Wenn Sie vor dem Senden abbrechen, werden die Daten nicht gespeichert. Sie gelangen dann zurück zur Use-Case-Übersicht und müssen die Angaben erneut eingeben.",
    "createKPIDocumentationDesclaimer": "Weitere Informationen zum Ausfüllen des Formulars und zu den Anforderungen Ihres OEM finden Sie in unserer {documentation}.",
    "documentation": "Dokumentation",
    "generalInformation": "Allgemeine Informationen",
    "measurementYear": "Messjahr",
    "receiverBpn": "Empfänger-BPN",
    "confirmationText": "Mit Absenden der Anfrage verstehe ich, dass der Vertrag über das Datenangebot gemäß den vom Datenanbieter festgelegten Policies ausgehandelt wird.",
    "successTitle": "Erfolgreich",
    "successDescription": "Ihre Daten wurden erfolgreich geteilt. Prozess-ID: {id}",
    "sendMetricsFailed": "Fehler beim Teilen Ihrer Daten.",
    "kpiKnowledgeBase": "Erfahren Sie mehr über den Use Case",
    "kpiFirstEntry": "Legen Sie los und erstellen Sie Ihren ersten Eintrag",
    "metricsInformation": {
      "title": "Angaben zur Kennzahl",
      "measurementDate": "Messdatum",
      "value": "Wert",
      "kpiNotSharedReason": "Grund, warum die Kennzahl nicht geteilt wird",
      "enclosedSiteTitle": "Zugehörige Standorte",
      "enclosedSiteLabel": "Wählen Sie Ihre zugehörigen Standorte aus"
    },
    "modal": {
      "leaveTitle": "Ohne Speichern verlassen?",
      "leaveDescription": "Wenn Sie dieses Formular jetzt schließen, gehen Ihre eingegebenen Daten verloren.",
      "discardBtn": "Änderungen verwerfen",
      "continueEditingBtn": "Weiter bearbeiten",
      "confirmTitle": "Senden bestätigen",
      "confirmDescription": "Nach dem Senden kann diese Nachricht nicht mehr bearbeitet oder zurückgezogen werden.",
      "confirmReviewBtn": "Eingabe bestätigen"
    },
    "helpCard": {
      "title": "Wie funktioniert es?",
      "description": "Teilen Sie Ihre jährlichen Cybersecurity-Kennzahlen mit BMW. Hier finden Sie eine vollständige Übersicht aller bisher erfassten Angaben.",
      "subtitle": "Möchten Sie mehr über den Use Case Cybersecurity-Kennzahlen erfahren?"
    },
    "metricsViewer": {
      "jobId": "jobId",
      "threadId": "threadId",
      "stepId": "stepId",
      "header": "header",
      "messageId": "messageId",
      "senderBpn": "senderBpn",
      "receiverBpn": "receiverBpn",
      "senderFeedbackUrl": "senderFeedbackUrl",
      "content": "content",
      "reportId": "reportId",
      "kpiShared": "kpiShared"
    }
  },
  "publicationTemplates": {
    "title": "Meine Veröffentlichungsvorlagen",
    "deletedTemplates": "Meine gelöschten Vorlagen",
    "showDeletedTemplates": "Gelöschte Vorlagen anzeigen",
    "hideDeletedTemplates": "Aktive Vorlagen anzeigen",
    "newTemplate": "Neue Vorlage",
    "create": {
      "title": "Veröffentlichungsvorlage erstellen",
      "edit": "Veröffentlichungsvorlage bearbeiten",
      "templateName": "Name der Vorlage",
      "templateType": "Vorlage ({type})",
      "create": "Erstellen",
      "update": "Aktualisieren",
      "modifiedAt": "Geändert am",
      "accessPolicyId": "Access Policy",
      "usagePolicyId": "Usage Policy",
      "isEnabled": "Aktiv",
      "targetCompany": "Zielunternehmen",
      "targetConnectors": "Ziel-Konnektoren",
      "selectCountry": "Wählen Sie ein Land aus",
      "templateDetails": "Details zur Veröffentlichungsvorlage",
      "assetsCriteria": "Kriterien für die Datensatzauswahl",
      "connectorDetails": "Details zum Konnektor"
    },
    "delete": {
      "title": "Veröffentlichungsvorlage löschen",
      "description": "Sind Sie sicher, dass Sie diese Vorlage löschen möchten?",
      "button": "Löschen"
    }
  },
  "contracts": {
    "title": "Details zu Vertragsvereinbarungen",
    "provider": {
      "description": "Dies ist eine Übersicht über Vertragsvereinbarungen, die Ihre Organisation mit anderen Datenraum-Teilnehmern hat.",
      "note": "Bitte beachten Sie, dass die folgende Liste die Daten aller Use Cases enthält. Eine vorgefilterte Ansicht sowie erweiterte Such- und Filtermöglichkeiten pro Use Case folgen in Kürze. Nutzen Sie bis dahin bitte die Such- und Filteroptionen, um die relevanten Daten zu finden.",
      "howItWorks": {
        "description": "Hier finden Sie alle Ihre ausgehandelten Datenverträge über verschiedene Datenräume hinweg. Sie können die Ergebnisse nach Konnektor filtern oder direkt nach einer Vertragsvereinbarungs-ID oder Asset-ID suchen. Die Liste lässt sich nach Ihren Anforderungen sortieren. Außerdem können Sie Datenangebote auswählen und bei Bedarf lokal exportieren.",
        "subtitle": "Möchten Sie mehr darüber erfahren, wie Datenangebote, Vertragsverhandlung und Datenbezug funktionieren?"
      },
      "details": {
        "title": "Details zu den bereitgestellten Vertragsvereinbarungen",
        "description": "Beschreibung",
        "content": "Inhalt",
        "agreementDetails": "Details zur Vereinbarung",
        "assetDetails": "Details zum Asset",
        "usagePolicy": "Usage Policy"
      }
    },
    "consumer": {
      "description": "Dies ist eine Übersicht über die Vertragsvereinbarungen, die Ihre Organisation für Datenangebote anderer Datenraum-Teilnehmer abgeschlossen hat.",
      "downloadData": "Daten herunterladen",
      "downloadAgreement": "Vereinbarung herunterladen",
      "reinitiate": "Datenübertragung und Download erneut starten",
      "error": {
        "heading": "Dieser Vertrag wurde bereits ausgehandelt.",
        "body": "Ein bereits ausgehandelter Vertrag kann nicht erneut verhandelt werden. Sie können die Vertragsdetails einsehen, die Vereinbarung herunterladen und die Daten beziehen."
      },
      "details": {
        "title": "Details zu bezogenen Vertragsvereinbarungen"
      },
      "howItWorks": {
        "description": "Hier finden Sie alle Ihre ausgehandelten Datenverträge über verschiedene Datenräume hinweg. Sie können die Ergebnisse nach Konnektor filtern oder direkt nach einer Vertragsvereinbarungs-ID oder Asset-ID suchen. Die Liste lässt sich nach Ihren Anforderungen sortieren. Außerdem können Sie Datenangebote auswählen und bei Bedarf lokal exportieren.",
        "subtitle": "Möchten Sie mehr darüber erfahren, wie Datenangebote, Vertragsverhandlung und Datenbezug funktionieren?"
      }
    }
  },
  "provider": {
    "provider": "Datenanbieter",
    "assets": {
      "title": "Meine Datensätze",
      "offeredBy": "Angeboten von:",
      "offers": "Angebote",
      "created": "Erstellt",
      "modifiedAt": "Geändert am",
      "noResultsFound": "Es wurden keine Datensätze gefunden",
      "success": "Datensatz erfolgreich erstellt",
      "updateSuccess": "Datensatz erfolgreich aktualisiert",
      "buttons": {
        "createOffer": "Angebot erstellen",
        "details": "Details anzeigen",
        "delete": "Datensatz löschen",
        "create": "Datensatz erstellen",
        "edit": "Datensatz bearbeiten",
        "update": "Datensatz aktualisieren",
        "showDeleted": "Gelöschte Datensätze anzeigen",
        "hideDeleted": "Gelöschte Datensätze ausblenden",
        "restore": "Datensatz wiederherstellen",
        "add": "Schlüssel-Wert-Paar hinzufügen",
        "addJson": "JSON-Objekt hinzufügen",
        "editJson": "JSON-Objekt bearbeiten",
        "saveJson": "JSON speichern",
        "advanceAddition": "Erweiterte Eigenschaften",
        "unpublish": "Veröffentlichung zurückziehen",
        "showAssets": "Datensätze anzeigen"
      },
      "detailsDialog": {
        "title": "Details zum Datensatz"
      },
      "createDialog": {
        "title": {
          "general": "Neuen Datensatz erstellen",
          "edit": "Datensatz bearbeiten",
          "addProperties": "Eigenschaften hinzufügen",
          "advance": "Erweiterte Eigenschaften hinzufügen"
        },
        "publicProps": "Öffentliche Eigenschaften",
        "privateProps": "Private Eigenschaften",
        "dataAddress": "Datenadresse",
        "dataSources": "Datenquelle",
        "dataDestination": "Zielsystem",
        "json": {
          "fields": "JSON-Felder",
          "editor": "Editor für benutzerdefinierte Eigenschaften",
          "formatted": "Viewer für benutzerdefinierte Eigenschaften",
          "error": "Ungültiges JSON:",
          "placeholder": "JSON mit benutzerdefinierten Eigenschaften eingeben"
        },
        "connectionTypeLabel": {
          "http": "Geben Sie die URL ein",
          "s3": "Geben Sie den Objektnamen ein",
          "azure": "Geben Sie den Namen des Blobs ein",
          "sftp": "Geben Sie den Dateinamen ein"
        },
        "fields": {
          "name": "Name",
          "namePlaceholder": "Namen des Angebots eingeben",
          "description": "Beschreibung",
          "version": "Version",
          "contentType": "Inhaltstyp",
          "contentTypePlaceholder": "Inhaltstyp eingeben",
          "keywords": "Schlüsselwörter",
          "language": "Sprache",
          "languagePlaceholder": "Sprache auswählen",
          "semanticId": "Semantische ID",
          "semanticIdPlaceholder": "Bitte geben Sie die semantische ID ein",
          "dct:type": "dct:type",
          "dct:typePlaceholder": "dct:type auswählen",
          "keywordsPlaceholder": "Schlüsselwörter hinzufügen",
          "descriptionPlaceholder": "Beschreibung des Angebots eingeben",
          "versionPlaceholder": "Versionsnummer",
          "dataType": "Typ der Datenadresse",
          "dataTypePlaceholder": "Typ der Datenadresse auswählen",
          "dataAddressUrl": "Datensatz-URL",
          "dataAddressUrlPlaceholder": "Geben Sie die Datensatz-URL ein",
          "targetCompany": "Erstellt für",
          "targetCompanyPlaceholder": "Zielunternehmen eingeben",
          "country": "Land",
          "countryPlaceholder": "Land auswählen",
          "key": "Schlüssel",
          "keyPlaceholder": "Geben Sie den Schlüssel ein",
          "value": "Wert",
          "valuePlaceholder": "Geben Sie den Wert ein",
          "assetType": "Datensatztyp",
          "assetTypePlaceholder": "Datensatztyp eingeben"
        },
        "validation": {
          "name": "Bitte geben Sie einen Namen ein",
          "assetType": "Bitte wählen Sie einen Datensatztyp aus",
          "contentType": "Bitte geben Sie einen gültigen Inhaltstyp ein",
          "dataType": "Bitte wählen Sie einen gültigen Datentyp aus",
          "targetCompany": "Bitte geben Sie ein gültiges Zielunternehmen ein",
          "country": "Bitte geben Sie ein gültiges Land ein"
        }
      },
      "tags": {
        "restricted": "Zugriff eingeschränkt",
        "unrestricted": "Zugriff uneingeschränkt"
      },
      "search": {
        "title": "Suchfilter",
        "helperText": "Suche nach Datensatzname, Erstellungsdatum oder Typ",
        "filters": {
          "byName": "Name des Datensatzes",
          "byType": "Datensatztyp",
          "byDate": "Änderungsdatum",
          "byAssetId": "Asset-ID"
        }
      },
      "delete": {
        "title": "Datensatz löschen",
        "description": "Sind Sie sicher, dass Sie diesen Datensatz löschen möchten?"
      },
      "unpublish": {
        "title": "Veröffentlichung zurückziehen",
        "description": "Möchten Sie die Veröffentlichung dieses Datensatzes wirklich zurückziehen?"
      }
    },
    "fileUploadTerms": "Ich bestätige, dass ich alle erforderlichen Angaben korrekt gemacht habe, und erkenne an, dass T-Systems bei fehlerhaften Angaben und einer daraus folgenden Ablehnung von Angeboten nicht haftet.",
    "fileUploadInfo": "T-Systems prüft die hier eingegebenen Metadaten nicht auf Richtigkeit. Bitte stellen Sie sicher, dass Ihre Angaben korrekt und vollständig sind.",
    "pdf": "PDF",
    "csv": "CSV",
    "singleEntry": "Einzeleintrag",
    "bulkEntries": "Mehrere Einträge"
  },
  "home": {
    "title": "Connect & Integrate",
    "welcomeBack": "Willkommen zurück"
  },
  "gettingStarted": {
    "title": "Benötigen Sie Hilfe beim Einstieg?",
    "openWizard": "Assistent öffnen",
    "yourDataOffering": "Ihr Datenangebot",
    "yourAssets": "Datensätze",
    "yourPolicies": "Policies",
    "preconfiguredCatalogue": "Vorkonfigurierter Katalog",
    "contractAgreements": "Vertragsvereinbarungen",
    "incomingAgreements": "Eingehende Vereinbarungen",
    "outgoingAgreements": "Ausgehende Vereinbarungen",
    "connectors": "Konnektoren",
    "providedAgreements": "Bereitgestellte Vertragsvereinbarungen",
    "consumedAgreements": "Bezogene Vertragsvereinbarungen",
    "totalContracts": "Verträge"
  },
  "yourConnection": {
    "title": "Ihre Konnektoren",
    "viewAllConnection": "Alle Konnektoren anzeigen",
    "help": "Hilfe",
    "documentation": "Connect & Integrate kennenlernen",
    "gettingStarted": "Leitfaden für die ersten Schritte",
    "noUseCases": "Keine Use Cases verfügbar",
    "activeUseCases": "Aktive Use Cases",
    "useCasesAvailableToActivate": "noch nicht aktivierte Use Cases",
    "open": "Öffnen",
    "show": "Anzeigen",
    "pcfVersionModal": {
      "title": "Versionen des PCF-Datenaustauschs",
      "description": "Connect & Integrate unterstützt die folgenden PCF-Versionen und PCF-Rulebook-Stände für den PCF-Datenaustausch im Catena-X-Netzwerk. Bitte wählen Sie Ihre bevorzugte Option. Bitte beachten Sie, dass die beiden Versionen unabhängig voneinander arbeiten.",
      "current": "Aktuell",
      "deprecated": "Veraltet",
      "rulebook": "PCF-Rulebook",
      "pcfSubmodel": "PCF-Submodell",
      "supportStatus": "Support-Status",
      "statusActive": "Aktiv",
      "statusEol": "Support eingestellt",
      "saturn": {
        "name": "Saturn",
        "description": "Aktuelle Version mit erweiterten Funktionen und vollständiger Unterstützung der aktuellen Nachhaltigkeitsstandards. Empfohlen für alle Neueinrichtungen."
      },
      "jupiter": {
        "name": "Jupiter",
        "description": "Vorgängerversion zur Abwärtskompatibilität. Wir empfehlen dringend, vor Ende des Supportzeitraums auf Saturn zu migrieren."
      }
    }
  },
  "wizardSelectionPopup": {
    "whatToLike": "Was möchten Sie tun?",
    "prepare": "Daten vorbereiten",
    "govern": "Datenaustausch regeln",
    "provide": "Daten bereitstellen",
    "consume": "Daten beziehen",
    "howToProvide": "Wie möchten Sie Ihre Daten bereitstellen?",
    "manual": "Manuell",
    "automated": "Automatisiert über API",
    "selectUseCases": "Wählen Sie einen oder mehrere Use Cases aus",
    "selectSingleUseCase": "Wählen Sie Ihren Use Case aus",
    "selectDigitalTwin": "Wählen Sie den Typ des digitalen Zwillings aus",
    "back": "Zurück",
    "publish": "Ich verstehe die Rahmenbedingungen des Datenraumes und stimme zu, das Datenangebot im Namen meiner Organisation im Datenraum zu veröffentlichen."
  },
  "createOffer": {
    "title": {
      "standard": "Datenangebot erstellen",
      "pcf": "PCF-Datenangebot erstellen",
      "certificate": "Zertifikatsangebot erstellen",
      "traceability": "Traceability-Datenangebot erstellen"
    },
    "publish": "Veröffentlichen",
    "legalConfirmation": "Ich verstehe die Rahmenbedingungen des Datenraums und bin damit einverstanden, das Datenangebot im Namen meiner Organisation im Datenraum zu veröffentlichen.",
    "wizard": {
      "provisionAsset": "Datensatz anlegen",
      "dataUpload": "Daten bereitstellen",
      "attachPolicy": "Policy zuweisen",
      "publishDataOffer": "Datenangebot veröffentlichen"
    },
    "provisionAsset": {
      "howToSelectSubmodel": "Für welches Submodell möchten Sie ein Datenangebot erstellen?",
      "selectSubmodel": "Submodell auswählen",
      "selectUsecase": "Wählen Sie einen Use Case aus",
      "selectDigitalTwinType": "Typ des digitalen Zwillings auswählen",
      "whichTypeToSelect": "Welchen Submodelltyp sollte ich auswählen?",
      "generalInformation": "Allgemeine Informationen",
      "description": "Beschreibung",
      "contentType": "Inhaltstyp",
      "keywords": "Schlüsselwörter",
      "language": "Sprache",
      "location": {
        "title": "Speicherort und Adresse",
        "text": "Bitte geben Sie die Details Ihres Datensatzes ein"
      },
      "username": "Benutzername",
      "password": "Passwort",
      "assetUrl": "Datensatz-URL",
      "assetUrlPlaceHolder": "Bitte geben Sie Ihre Datensatz-URL ein",
      "clientId": "Client-ID",
      "clientSecret": "Client-Secret",
      "tokenUrl": "Token-URL",
      "tokenUrlPlaceHolder": "Bitte fügen Sie Ihre Token-URL ein",
      "provideAssets": "Datensatz bereitstellen",
      "selectConnectorLabel": "Wählen Sie aus, über welche Konnektoren Sie Ihre Daten teilen möchten",
      "selectConnectorPlaceholder": "Wählen Sie einen Konnektor aus",
      "selectRestApiType": "REST-API-Typ auswählen",
      "selectedAuthMethod": "Authentifizierungsmethode"
    },
    "dataUpload": {
      "selectUploadType": "Art der Bereitstellung auswählen",
      "selectedDataModel": "Wählen Sie Ihre Daten aus",
      "csvUpload": {
        "title": "CSV-Datei",
        "description": "Ziehen Sie Ihre Dateien hierher oder laden Sie sie hoch",
        "uploadFile": "Datei auswählen",
        "uploadFileDescription": "Bereiten Sie die Datei vor, die Sie austauschen möchten, und laden Sie sie hoch. Die Beispieldatei zeigt Ihnen das für Catena-X erforderliche Format.",
        "uploadFileDescriptionNote1": "Laden Sie die Vorlage über den untenstehenden Link herunter",
        "uploadFileDescriptionNote2": "Ergänzen Sie die Vorlage mit den Angaben zu Ihren Partnern",
        "uploadFileDescriptionNote3": "Laden Sie die Datei im dafür vorgesehenen Bereich hoch",
        "partnerValidationNote": "Weitere Informationen zur Partnervalidierung finden Sie",
        "clickHere": "hier",
        "downloadTemplate": "Vorlage herunterladen",
        "downloadSampleCsv": "Beispiel-CSV herunterladen",
        "supportedFileTypes": "Unterstützte Dateitypen:"
      },
      "jsonUpload": {
        "title": "JSON",
        "submodelJson": "Submodell-JSON",
        "downloadTemplate": "Vorlage herunterladen",
        "downloadSampleJson": "Beispiel-JSON herunterladen",
        "uploadFileDescription": "Bereiten Sie die Datei vor, die Sie austauschen möchten, und laden Sie sie hoch.",
        "invalidJson": "Der Inhalt ist kein gültiges JSON. Bitte prüfen Sie Ihre Eingabe und versuchen Sie es erneut.",
        "schemaValidationFailed": "Catena-X-Schemavalidierung fehlgeschlagen",
        "issue": "Problem",
        "issues": "Probleme"
      },
      "operationMode": {
        "title": "Betriebsmodus auswählen",
        "description": "Legen Sie fest, wie die Verwaltungsschale (AAS) für diesen digitalen Zwilling bereitgestellt wird.",
        "createNew": {
          "title": "Neuen digitalen Zwilling erstellen",
          "description": "Eine neue Verwaltungsschale (AAS) in CX-Core registrieren"
        },
        "useExisting": {
          "title": "Vorhandenen digitalen Zwilling verwenden",
          "description": "Mit einer bereits in CX-Core vorhandenen Verwaltungsschale (AAS) verknüpfen"
        }
      },
      "useExisting": {
        "searchTitle": "Vorhandene Verwaltungsschale (AAS) in CX-Core suchen",
        "catenaXId": "Catena-X-ID",
        "search": "Suchen",
        "reset": "Zurücksetzen",
        "noResults": "Keine passenden digitalen Zwillinge gefunden.",
        "searchError": "Suche nach digitalen Zwillingen fehlgeschlagen. Bitte versuchen Sie es erneut.",
        "matchingTypeNote": "Es werden nur Verwaltungsschalen angezeigt, die dem ausgewählten Typ des digitalen Zwillings entsprechen.",
        "propertiesTitle": "Eigenschaften des digitalen Zwillings",
        "readOnly": "(schreibgeschützt)"
      },
      "digitalTwinProperties": {
        "title": "Eigenschaften des digitalen Zwillings",
        "specificAssetIds": "Spezifische Asset-IDs"
      },
      "tableUpload": {
        "title": "Tabelle",
        "description": "Eigene Tabelleneinträge bereitstellen",
        "add": "Hinzufügen"
      },
      "fileUpload": {
        "title": "Datei hochladen",
        "description": "csv, json"
      },
      "objectStorage": {
        "title": "Objektspeicher",
        "description": "AWS, Azure, OTC oder GCP"
      },
      "sftp": {
        "title": "SFTP-Server",
        "description": "Übertragung per SFTP"
      },
      "apiUpload": {
        "title": "REST-API",
        "description": "Übertragung über API",
        "authAndIdentiTitle": "Authentifizierung und Identifikation",
        "authAndIdentiDesc": "Bitte geben Sie die Authentifizierungsdaten Ihres Zielsystems ein",
        "selectApiType": "REST-API-Typ auswählen",
        "locationAndAddrTitle": "Speicherort und Adressierung",
        "locationAndAddrDesc": "Bitte geben Sie die Details Ihres Datensatzes ein",
        "assetUrl": "Datensatz-URL",
        "username": "Benutzername",
        "password": "Passwort",
        "clientId": "Client-ID",
        "clientSecret": "Client-Secret"
      }
    },
    "fileUpload": {
      "title": "Datei hierher ziehen und ablegen",
      "btnText": "Datei auswählen"
    },
    "attachPolicy": {
      "title": "Weisen Sie diesem Datenangebot eine Policy zu",
      "createPolicy": "Neue Policy erstellen",
      "bpnFieldTitle": "Mit wem möchten Sie Ihre Daten austauschen?",
      "howItWork": {
        "title": "Wie funktioniert es?",
        "description": "Die Policies sind auf Basis der Catena-X-Rahmenvereinbarung für den jeweiligen Use Case vorkonfiguriert. Der Zugriff auf Ihre Daten ist nur für die angegebenen Geschäftspartnernummern (BPN) gestattet.",
        "knowMore": "Möchten Sie mehr über die Policies erfahren?",
        "documentation": "Dokumentation"
      },
      "accessPolicyTableText": "Weisen Sie diesem Datenangebot eine Access Policy zu",
      "usagePolicyTableText": "Weisen Sie diesem Datenangebot eine Usage Policy zu",
      "heading": {
        "title": "Vorhandene Policies zuweisen oder neue erstellen",
        "description": "Weisen Sie aus den folgenden Tabellen sowohl eine Access Policy als auch eine Usage Policy zu, um die Veröffentlichung des Datenangebots abzuschließen. Sie können Policies über ihren Namen suchen oder eine neue Policy erstellen, falls noch keine passende vorhanden ist."
      }
    },
    "publishDataOffer": {
      "dataOfferDetails": "Details zum Datenangebot",
      "generalInformation": "Allgemeine Informationen",
      "attribute": "Attribut",
      "value": "Wert",
      "knowMore": "Erfahren Sie mehr über Ihr Datenangebot",
      "attachedDataAssets": "Zugewiesene Datensätze",
      "attachedPolicies": "Zugewiesene Policies",
      "allowPolicyPublish": "Ich erlaube die Veröffentlichung von Policies",
      "publish": "Veröffentlichen",
      "verifiedLegalEntity": "Verifizierte Rechtseinheit von",
      "dataOfferCreatedBy": "Datenangebot erstellt von: ",
      "contactOrgAdmin": "Kontakt zum Organisationsadministrator",
      "help": "Hilfe",
      "attachedDataAsset": "Zugewiesener Datensatz",
      "attachedAccessPolicy": "Zugewiesene Access Policy",
      "attachedUsagePolicy": "Zugewiesene Usage Policy",
      "publishedConnectors": "Konnektoren, durch die dieses Angebot veröffentlicht wird",
      "knowMoreConnector": "Erfahren Sie mehr über Ihre Konnektoren",
      "knowMorePolicies": "Erfahren Sie mehr über Ihre Policies",
      "knowMoreDataAssets": "Erfahren Sie mehr über Ihre Datensätze",
      "knowMoreDataOffers": "Erfahren Sie mehr über Ihr Datenangebot",
      "publishCheckboxLabel": "Ich stimme im Namen meiner Organisation zu, das Datenangebot und die zugehörigen Datensätze im Datenraum zu veröffentlichen. Ich bestätige, dass die zugewiesenen Policies den Zugriff auf die Daten und deren Nutzung regeln, und verpflichte mich, die Rahmenbedingungen des Datenraums für alle Vorgänge im Zusammenhang mit diesem Angebot und den Datensätzen einzuhalten."
    },
    "result": {
      "success": {
        "title": "Anfrage erfolgreich.",
        "description": "Die Veröffentlichung des Datensatzes wurde gestartet. Prozess-ID: {id}"
      }
    },
    "success": {
      "title": "Ihr Datenangebot ist nun veröffentlicht",
      "description": "Ihr Datenangebot ist jetzt veröffentlicht. Wählen Sie einen der folgenden nächsten Schritte.",
      "createOffer": "Ein weiteres Datenangebot erstellen",
      "createOfferButton": "Erstellen",
      "goToHome": "Zur Startseite",
      "goToHomeButton": "Zur Startseite",
      "uploadHistory": "Upload-Verlauf prüfen"
    }
  },
  "policy": {
    "newPolicy": "Neue Policy",
    "showDeletedPolicies": "Gelöschte Policies anzeigen",
    "myDeletedPolicies": "Meine gelöschten Policies",
    "hideDeletedPolicies": "Aktive Policies anzeigen",
    "restoreAsset": "Wiederherstellen",
    "publishDeletion": "Löschung veröffentlichen",
    "create": {
      "title": "Neue Policy erstellen",
      "edit": "Policy bearbeiten",
      "policyName": "Name der Policy",
      "policyType": "Policy ({type})",
      "accessPolicy": "Access Policy",
      "usagePolicy": "Usage Policy",
      "create": "Erstellen und speichern",
      "update": "Aktualisieren"
    },
    "delete": {
      "title": "Policy löschen",
      "description": "Sind Sie sicher, dass Sie diese Policy löschen möchten?",
      "button": "Löschen"
    },
    "types": {
      "BusinessPartnerNumber": {
        "title": "Geschäftspartnernummer",
        "description": "Mit der Beschränkung auf Geschäftspartnernummern legen Sie fest, welche Geschäftspartner (anhand ihrer BPNL) das Datenangebot einsehen und darüber verhandeln dürfen. Geben Sie mindestens eine 16-stellige BPNL als Wert (rightOperand) an. Platzhalter (Wildcards) werden nicht unterstützt."
      },
      "BusinessPartnerGroup": {
        "title": "Geschäftspartnergruppe",
        "description": "Mit der Beschränkung auf Geschäftspartnergruppen legen Sie fest, welche Gruppe von Geschäftspartnern (anhand ihrer BPNL) das Datenangebot einsehen und darüber verhandeln darf, z. B. BusinessPartnerWithoutBilateralContract."
      },
      "Membership": {
        "title": "Mitgliedschaft",
        "description": "Mit dem Mitgliedschaftsnachweis (Membership Credential) stellen Sie sicher, dass nur Catena-X-Teilnehmer das Datenangebot einsehen und darüber verhandeln dürfen."
      },
      "ContractReference": {
        "title": "Vertragsreferenz",
        "description": "Mit der Vertragsreferenz legen Sie fest, unter welchem bilateralen Vertrag die Daten geteilt werden. Der genaue Vertragsname muss als Wert (rightOperand) angegeben werden."
      },
      "Dismantler.allowedBrands": {
        "title": "Demontagebetrieb: zugelassene Marken",
        "description": "Beschränkt den Zugriff auf zertifizierte Demontagebetriebe, die für die angegebenen Fahrzeugmarken zugelassen sind."
      },
      "UsagePurpose": {
        "title": "Nutzungszweck",
        "description": "Legt fest, für welchen Zweck die Daten genutzt werden dürfen."
      },
      "FrameworkAgreement": {
        "title": "Rahmenvereinbarung",
        "description": "Mit dem Nachweis der Rahmenvereinbarung (Framework Agreement Credential) dürfen nur Teilnehmer das Datenangebot einsehen und darüber verhandeln, die die entsprechende Rahmenvereinbarung für den Use Case (allgemein oder in einer bestimmten Version) unterzeichnet haben."
      },
      "Dismantler": {
        "title": "Demontagebetrieb",
        "description": "Nur Unternehmen mit dem entsprechenden Nachweis (Credential) gelten als zertifizierte Demontagebetriebe.",
        "allowedBrands": {
          "title": "Demontagebetrieb: zugelassene Marken",
          "description": "Beschränkt den Zugriff auf zertifizierte Demontagebetriebe, die für die angegebenen Fahrzeugmarken zugelassen sind."
        }
      },
      "Duration": {
        "title": "Dauer",
        "description": "Dauer der Datennutzung ab dem Datum der Vertragsunterzeichnung."
      },
      "inForceDate": {
        "title": "Fester Datumsbereich",
        "description": "Fester Zeitraum für die Datennutzung."
      },
      "connector": {
        "title": "Konnektor-Beschränkung",
        "description": "Beschränkt den Zugriff auf bestimmte Konnektoren."
      },
      "AffiliatesBpnl": {
        "title": "Verbundene Unternehmen (BPNL)",
        "description": "Dokumentiert (prüft nicht), welche verbundenen Unternehmen die Daten ebenfalls nutzen dürfen."
      },
      "AffiliatesRegion": {
        "title": "Region der verbundenen Unternehmen",
        "description": "Dokumentiert (prüft nicht), in welchen Regionen verbundene Unternehmen die Daten nutzen dürfen."
      },
      "ConfidentialInformationMeasures": {
        "title": "Maßnahmen für vertrauliche Informationen",
        "description": "Dokumentiert (prüft nicht), ob Maßnahmen zum Schutz vertraulicher Informationen erforderlich sind."
      },
      "ConfidentialInformationSharing": {
        "title": "Weitergabe vertraulicher Informationen",
        "description": "Dokumentiert (prüft nicht), ob und an wen vertrauliche Informationen weitergegeben werden dürfen."
      },
      "ContractTermination": {
        "title": "Vertragsbeendigung",
        "description": "Dokumentiert (prüft nicht), wie der Datennutzer nach Vertragsende mit den Daten umgehen muss."
      },
      "DataFrequency": {
        "title": "Datenfrequenz",
        "description": "Dokumentiert (prüft nicht), wie häufig die Daten übertragen werden."
      },
      "DataProvisioningEndDate": {
        "title": "Ende der Datenbereitstellung",
        "description": "Dokumentiert (prüft nicht) das Datum, an dem die Bereitstellung der Daten endet."
      },
      "DataProvisioningEndDurationDays": {
        "title": "Dauer der Datenbereitstellung (Tage)",
        "description": "Dokumentiert (prüft nicht), wie viele Tage die Daten bereitgestellt werden."
      },
      "DataUsageEndDate": {
        "title": "Ende der Datennutzung",
        "description": "Dokumentiert (prüft nicht) das Datum, an dem die Nutzung der Daten endet."
      },
      "DataUsageEndDurationDays": {
        "title": "Dauer der Datennutzung (Tage)",
        "description": "Dokumentiert (prüft nicht), wie viele Tage die Daten genutzt werden dürfen."
      },
      "DataUsageEndDefinition": {
        "title": "Definition des Endes der Datennutzung",
        "description": "Dokumentiert (prüft nicht), wie das Ende der Datennutzung definiert ist."
      },
      "JurisdictionLocation": {
        "title": "Gerichtsstand",
        "description": "Dokumentiert (prüft nicht) den Gerichtsstand dieses Vertrags im Klartext."
      },
      "JurisdictionLocationReference": {
        "title": "Gerichtsstandsreferenz",
        "description": "Dokumentiert (prüft nicht) den Gerichtsstand dieses Vertrags in Bezug auf die beteiligten Parteien."
      },
      "Liability": {
        "title": "Haftung",
        "description": "Dokumentiert (prüft nicht) die Haftungsregelung dieses Vertrags zwischen den beteiligten Parteien."
      },
      "ManagedLegalEntityBpnl": {
        "title": "Verwaltete Rechtseinheit (BPNL)",
        "description": "Dokumentiert (prüft nicht), für welche Geschäftspartner der Datenanbieter den Datensatz verwaltet."
      },
      "ManagedLegalEntityRegion": {
        "title": "Region der verwalteten Rechtseinheit",
        "description": "Dokumentiert (prüft nicht), für welche Region der Datenanbieter den Datensatz verwaltet."
      },
      "Precedence": {
        "title": "Vorrang",
        "description": "Dokumentiert (prüft nicht), welcher Vertragsrahmen Vorrang hat."
      },
      "ExclusiveUsage": {
        "title": "Exklusive Nutzung",
        "description": "Dokumentiert (prüft nicht), dass der Datensatz exklusiv für diesen Datennutzer angeboten wird."
      },
      "UsageRestriction": {
        "title": "Nutzungsbeschränkung",
        "description": "Dokumentiert (prüft nicht), welche Nutzungen dem Datennutzer untersagt sind."
      },
      "VersionChanges": {
        "title": "Versionsänderungen",
        "description": "Dokumentiert (prüft nicht), welche Art von Versionsänderungen am Datensatz auftreten können."
      },
      "Warranty": {
        "title": "Gewährleistung",
        "description": "Dokumentiert (prüft nicht), welche Gewährleistung der Datennutzer für den Datensatz erhält."
      },
      "WarrantyDefinition": {
        "title": "Gewährleistungsdefinition",
        "description": "Dokumentiert (prüft nicht), wie die Gewährleistung für den Datensatz definiert ist."
      },
      "WarrantyDurationMonths": {
        "title": "Gewährleistungsdauer (Monate)",
        "description": "Dokumentiert (prüft nicht) die Gewährleistungsdauer für den Datensatz in Monaten."
      }
    },
    "fields": {
      "BusinessPartnerNumber": "Geschäftspartnernummer",
      "tx:BusinessPartnerGroup": "Geschäftspartnergruppe",
      "cx-policy:Membership": "Mitgliedschaft",
      "cx-policy:ContractReference": "Vertragsreferenz",
      "cx-policy:Dismantler.allowedBrands": "Demontagebetrieb: zugelassene Marken",
      "cx-policy:UsagePurpose": "Nutzungszweck",
      "cx-policy:FrameworkAgreement": "Rahmenvereinbarung",
      "cx-policy:Dismantler": "Demontage",
      "duration": "Dauer",
      "unit": "Einheit",
      "fromdate": "Startdatum",
      "todate": "Enddatum",
      "connector": "Konnektor",
      "cx-policy:AffiliatesBpnl": "Verbundene Unternehmen (BPNL)",
      "cx-policy:AffiliatesRegion": "Region der verbundenen Unternehmen",
      "cx-policy:ConfidentialInformationMeasures": "Maßnahmen für vertrauliche Informationen",
      "cx-policy:ConfidentialInformationSharing": "Weitergabe vertraulicher Informationen",
      "cx-policy:ContractTermination": "Vertragsbeendigung",
      "cx-policy:DataFrequency": "Datenfrequenz",
      "cx-policy:DataProvisioningEndDate": "Ende der Datenbereitstellung",
      "cx-policy:DataProvisioningEndDurationDays": "Dauer der Datenbereitstellung (Tage)",
      "cx-policy:DataUsageEndDate": "Ende der Datennutzung",
      "cx-policy:DataUsageEndDurationDays": "Dauer der Datennutzung (Tage)",
      "cx-policy:DataUsageEndDefinition": "Definition des Endes der Datennutzung",
      "cx-policy:JurisdictionLocation": "Gerichtsstand",
      "cx-policy:JurisdictionLocationReference": "Gerichtsstandsreferenz",
      "cx-policy:Liability": "Haftung",
      "cx-policy:ManagedLegalEntityBpnl": "Verwaltete Rechtseinheit (BPNL)",
      "cx-policy:ManagedLegalEntityRegion": "Region der verwalteten Rechtseinheit",
      "cx-policy:Precedence": "Vorrang",
      "cx-policy:ExclusiveUsage": "Exklusive Nutzung",
      "cx-policy:UsageRestriction": "Nutzungsbeschränkung",
      "cx-policy:VersionChanges": "Versionsänderungen",
      "cx-policy:Warranty": "Gewährleistung",
      "cx-policy:WarrantyDefinition": "Gewährleistungsdefinition",
      "cx-policy:WarrantyDurationMonths": "Gewährleistungsdauer (Monate)"
    }
  },
  "jobs": {
    "jobs": "Prozesse",
    "allApplicationsNote": "Diese Ansicht zeigt die Protokolle aller Anwendungen. Der anwendungsspezifische Protokollverlauf folgt in Kürze.",
    "name": "Name",
    "startedAt": "Gestartet am",
    "duration": "Dauer",
    "jobDetails": "Details zum Prozess",
    "reload": "Neu laden",
    "noDetailsAvailable": "Für diesen Prozess sind keine weiteren Details verfügbar",
    "retry": "Erneut ausführen"
  },
  "search-offer": {
    "pageTitle": "Datenangebote suchen",
    "pcfTitle": "PCF-Datenangebote suchen",
    "pcfV9Title": "PCF-Datenangebote suchen (Saturn)",
    "certificateTitle": "Zertifikatsangebote von Geschäftspartnern suchen",
    "filter": {
      "bpnSearch": "Nach Geschäftspartnernummer (BPN) oder Firmenname suchen",
      "bpnSearchNote": "Finden Sie Datenangebote über den Firmennamen oder die BPN.",
      "manufacturePartId": "Hersteller-Teilenummer",
      "manufacturePartIdNote": "Findet alle Datenangebote zur angegebenen Teilenummer.",
      "enter": "{field} eingeben",
      "connectorUrl": "Konnektor-URL",
      "connectorUrlNote": "Nur in bestimmten Konnektoren suchen",
      "subModel": "Submodell",
      "subModelNote": "Grenzen Sie die Ergebnisse auf Ihren Use Case ein",
      "search": "Suche",
      "searchBy": "Suche nach",
      "resetFilters": "Filter zurücksetzen",
      "advancedSearch": "Erweiterte Suche",
      "dct:type": "dct:type",
      "assetId": "Asset-ID"
    },
    "noResult": {
      "title": "Keine Ergebnisse",
      "description": "Starten Sie eine Suche, um die verfügbaren Datenangebote im Netzwerk anzuzeigen."
    },
    "helpCard": {
      "title": "Wie funktioniert es?",
      "description": "Durchsuchen Sie den Datenangebotskatalog anderer Datenraum-Teilnehmer. Sie können verfügbare Datenangebote suchen, auswählen und beziehen.",
      "subtitle": "Möchten Sie mehr darüber erfahren, wie Datenangebote, Vertragsverhandlung und Datenbezug funktionieren?",
      "documentation": "Dokumentation"
    },
    "offers": {
      "downloadSelected": "Auswahl herunterladen",
      "transferSelected": "Auswahl übertragen",
      "negotiate": "Verhandeln",
      "noOffer": "Es sind keine Datenangebote verfügbar."
    },
    "offer-details": {
      "title": "Vertragsverhandlung bestätigen",
      "description": "Beschreibung",
      "attachedPolicies": "Zugewiesene Policies",
      "termsCheck": "Ich stimme den Vertragsbedingungen zu und möchte die Vertragsverhandlung und den Datenaustausch starten.",
      "negotiate": "Verhandeln",
      "negotiateAndDownload": "Verhandeln und herunterladen",
      "negotiateAndTransfer": "Verhandeln und übertragen",
      "transfer": "Übertragen",
      "cancel": "Abbrechen",
      "attribute": "Attribut",
      "value": "Wert",
      "endpointUrl": "Endpunkt-URL",
      "organization": "Organisation",
      "bpnNumber": "BPN",
      "manufacturerPartId": "Hersteller-Teilenummer",
      "noOfAssets": "Anzahl ausgewählter Datensätze",
      "membership": "Mitgliedschaft",
      "dismantlerBrands": "Zugelassene Marken (Demontagebetrieb)",
      "frameworkAgreement": "Rahmenvereinbarung",
      "dismantler": "Demontagebetrieb",
      "backToAssets": "Zurück zu den Datensätzen",
      "noPolicyMatchTitle": "Vertrag nicht ausgehandelt oder Policies nicht identisch",
      "noPolicyMatchText": "Sie versuchen, Datensätze herunterzuladen, für die noch kein Vertrag ausgehandelt wurde. Oder einige der ausgewählten Datensätze haben keine identischen Policies. Bitte wählen Sie passende Datensätze aus und fahren Sie fort.",
      "negotiateInProgress": "Verhandlung und Download laufen",
      "negotiateAndDownloadSuccess": "Verhandlung und Download erfolgreich abgeschlossen",
      "negotiateAndTransferSuccess": "Verhandlung und Übertragung erfolgreich abgeschlossen",
      "transferSuccess": "Übertragung erfolgreich abgeschlossen",
      "progress": "Fortschritt",
      "fetchShell": "Verwaltungsschale abrufen",
      "exportToCSV": "In CSV exportieren",
      "fetchJobFailed": "Fehler beim Abrufen der Prozessdetails",
      "negotiateError": "Fehler beim Herunterladen von Datensätzen",
      "dtr": "Digital Twin Registry (DTR)",
      "edc": "Konnektor (EDC)",
      "browseDtr": "Digital Twin Registry durchsuchen"
    },
    "existingContracts": {
      "heading": "Bestehende Verträge",
      "description": "Für dieses Datenangebot liegen bereits ausgehandelte Verträge vor."
    },
    "dtr": {
      "title": "Verwaltungsschalen (AAS)",
      "shells": "Verwaltungsschalen durchsuchen",
      "description": "Der Abruf und Export der Verwaltungsschalen aus der Digital Twin Registry des ausgewählten Anbieters wird automatisch verhandelt.",
      "noPoliciesFound": "Für diesen Datensatz wurden keine Policies gefunden",
      "errorFetchingPolicies": "Fehler beim Abrufen der Policies.",
      "negotiate": "Verhandeln"
    },
    "traceabilityTitle": "Traceability-Daten finden"
  },
  "catalogSimulation": {
    "pageTitle": "Datenangebote simulieren",
    "note": "Prüfen Sie, welche Ihrer bestehenden Datenangebote für einen bestimmten Dataspace-Teilnehmer sichtbar wären. Simulieren Sie einen anderen Dataspace-Teilnehmer und wählen Sie die Legitimationen/Nachweise aus, von denen Sie annehmen, dass sie in dessen Wallet verfügbar sind. Die Simulation überprüft, ob Ihre konfigurierten Zugriffs- und Nutzungsrichtlinien den Zugriff auf die vorgesehenen Angebote gewähren. Nutzen Sie diese Funktion, um Ihre Datenangebote zu validieren und Konfigurationsprobleme bei den Richtlinien zu identifizieren, die andere Teilnehmer am Zugriff hindern könnten.",
    "protocol": "Dataspace Protocol",
    "protocolSaturn": "DSP Saturn",
    "protocolJupiter": "DSP Jupiter",
    "bpnSearch": "Nach Geschäftspartnernummer (BPN) oder Firmenname suchen",
    "credentials": "Legitimation/Nachweise",
    "credentialsNote": "Wählen Sie die den simulierten Teilnehmern bereitgestellten Legitimationen/Nachweise aus.",
    "simulate": "Simuliere",
    "policy": "Richtlinie",
    "credential": {
      "bpn": "Geschäftspartnernummer (BPN)",
      "membership": "Mitgliedschaft",
      "dataExchangeGovernance": "Datenaustausch Regelwerk",
      "sampleDismantler": "Demontage (Beispiel)"
    },
    "viewPolicy": "Richtlinie anzeigen"
  },
  "assetUploadHistory": {
    "title": "Upload-Verlauf",
    "subtitle": "Dieser Verlauf gibt Ihnen einen Überblick über die Transaktionen auf den Datenraum-Konnektoren Ihres Unternehmens. Hier sind alle Aktivitäten zu Datensätzen, Policies und Vertragsdefinitionen aufgeführt.",
    "refresh": "Aktualisieren",
    "processId": "Prozess-ID",
    "providerUrl": "Anbieter-URL",
    "createdOn": "Erstellt am",
    "totalItems": "Einträge gesamt",
    "successful": "Erfolgreich",
    "failed": "Fehlgeschlagen",
    "startDate": "Startdatum",
    "endDate": "Enddatum",
    "howItWork": {
      "title": "Wie funktioniert es?",
      "description": "Hier finden Sie alle Datensätze, die Sie in verschiedenen Datenräumen bereitgestellt haben. Sie können die Dateien erneut lokal herunterladen oder an einen externen Speicherort übertragen. Bei Fehlern wiederholen Sie bitte den Download oder verhandeln Sie das Datenangebot neu.",
      "moreInfo": "Möchten Sie mehr über den Upload-Verlauf erfahren und darüber, was Sie hier alles tun können?"
    }
  },
  "assetDownloadHistory": {
    "subtitle": "Dieser Verlauf gibt Ihnen einen Überblick über die Daten, die Ihre Organisation auf Basis ausgehandelter Verträge aus dem Datenraum bezogen hat. Bei Bedarf können Sie die Daten aus dieser Liste erneut herunterladen.",
    "howItWorks": {
      "description": "Hier finden Sie alle Datensätze, die Sie aus verschiedenen Datenräumen bezogen haben. Sie können die Dateien erneut lokal herunterladen oder an einen externen Speicherort übertragen. Bei Fehlern wiederholen Sie bitte den Download oder verhandeln Sie das Datenangebot neu.",
      "moreInfo": "Möchten Sie mehr über den Download-Verlauf erfahren und darüber, was Sie hier alles tun können?"
    },
    "downloadError": "Download fehlgeschlagen. Bitte versuchen Sie es erneut.",
    "viewErrors": "Fehler anzeigen",
    "processId": "Prozess-ID"
  },
  "digitalTwinBrowser": {
    "subHeading": "Hier sehen Sie Ihre digitalen Zwillinge und deren Submodelle. Ihre digitalen Zwillinge werden über Ihre Digital Twin Registry im Datenraum bereitgestellt.",
    "noDocumentError": "Kein Aspektdokument für diese ID vorhanden",
    "nameNotProvided": "Name nicht angegeben",
    "fetchDigitalTwinsError": "Fehler beim Abrufen digitaler Zwillinge",
    "fetchAspectDocumentError": "Fehler beim Abrufen des Aspektdokuments",
    "fetchAspectModelError": "Fehler beim Abrufen des Aspektmodells",
    "detailsOverviewModalTitle": "Details zum Aspekt",
    "addItem": "Element hinzufügen",
    "detailsTable": {
      "idShort": "Kurz-ID (idShort)",
      "displayName": "Anzeigename",
      "modelUrn": "Modell-URN"
    },
    "shellsTable": {
      "manufacturer": "Hersteller-Teilenummer",
      "modifiedBy": "Geändert von",
      "modifiedAt": "Geändert am"
    }
  },
  "connector": {
    "addNewConnector": "+ Neuen Konnektor hinzufügen",
    "searchConnector": "Nach Konnektor-Namen suchen",
    "connectorModal": {
      "error": "Konnektor-Details konnten nicht abgerufen werden"
    }
  },
  "column": {
    "name": "Name",
    "connectorName": "Konnektor-Name",
    "contractId": "Vertrags-ID",
    "productId": "Produkt-ID",
    "manufacturerPartId": "Hersteller-Teilenummer",
    "manufacturerId": "Hersteller-ID",
    "digitalTwinType": "Typ des digitalen Zwillings",
    "correlationId": "Korrelations-ID",
    "requestId": "Anfrage-ID",
    "bpn": "BPN",
    "createdAt": "Erstellt am",
    "createdBy": "Erstellt von",
    "attribute": "Attribut",
    "value": "Wert",
    "url": "URL",
    "actions": "Aktionen",
    "lastUpdatedTime": "Zeitpunkt der letzten Aktualisierung",
    "status": "Status",
    "requestedDate": "Angefragt am",
    "policyType": "Typ der Policy",
    "modifiedBy": "Geändert von",
    "modifiedOn": "Geändert am",
    "syncStatus": "Synchronisationsstatus",
    "assetId": "Asset-ID",
    "assetType": "Datensatztyp",
    "type": "Typ",
    "createdFrom": "Erstellt ab",
    "createdTo": "Erstellt bis",
    "statusDuration": "Status/Dauer",
    "certifier": "Zertifizierer",
    "version": "Version",
    "registrationNumber": "Registrierungsnummer",
    "validUntil": "Gültig bis",
    "offerId": "Angebots-ID",
    "errorMessage": "Fehlermeldung",
    "globalAssetId": "Globale Asset-ID",
    "shellName": "Name der Verwaltungsschale",
    "contractAgreementId": "Vertragsvereinbarungs-ID",
    "signingDate": "Vertragsabschluss",
    "providerConnectorUrl": "Konnektor-URL (Anbieter)",
    "consumerConnectorUrl": "Konnektor-URL (Partner)",
    "providerBpnl": "BPNL (Anbieter)",
    "consumerBpnl": "BPNL (Partner)",
    "counterPartyId": "Gegenpartei-ID",
    "resourceId": "Ressourcen-ID",
    "resourceType": "Ressourcentyp",
    "transactionMethod": "Transaktionsmethode",
    "trustLevel": "Vertrauensstufe",
    "intrinsicId": "Seriennummer",
    "partId": "Teilenummer",
    "sentBy": "Gesendet von",
    "partner": "Partner",
    "sentOn": "Gesendet am",
    "id": "ID",
    "catenaXId": "Catena-X-ID",
    "customerPartId": "Kunden-Teilenummer"
  },
  "messagesBrowser": {
    "fetchMessagesError": "Fehler beim Abrufen von Nachrichten",
    "openRelatedMessage": "Verwandte Nachricht öffnen",
    "messagesTable": {
      "context": "Kontext",
      "senderBpn": "Absender-BPN",
      "receiverBpn": "Empfänger-BPN",
      "correlationId": "Korrelations-ID",
      "jobId": "Prozess-ID",
      "conversationId": "Konversations-ID"
    },
    "messageType": {
      "ecu": "ECU",
      "generic": "Generisch",
      "quality": "Qualität",
      "ccmpush": "CCM-Push",
      "ccmrequest": "CCM-Anfrage",
      "ccmstatus": "CCM-Status",
      "ccmavailable": "CCM verfügbar",
      "alert": "Qualitätswarnung",
      "investigation": "Qualitätsuntersuchung",
      "blockNotification": "Sperrmeldung",
      "dtrEvent": "DTR-Ereignis",
      "csm": "CSM"
    }
  },
  "bpnSelector": {
    "selectFromList": "Aus Liste auswählen",
    "enterManually": "Manuell eingeben",
    "selectPlaceholder": "Wählen Sie eine Standort-BPN aus",
    "manualPlaceholder": "BPN eingeben (z. B. BPNL123456789ABC)",
    "validFormat": "Gültiges BPN-Format",
    "invalidFormat": "Ungültiges BPN-Format",
    "invalidFormatHint": "Format: BPNL + 12 alphanumerische Zeichen",
    "formatHint": "Format: BPNL123456789ABC (insgesamt 16 Zeichen)",
    "selected": "Ausgewählt"
  },
  "searchableSelect": {
    "pressEnterToUse": "Drücken Sie die Eingabetaste, um diese BPNA/BPNS zu verwenden",
    "placeholderText": "Bitte geben Sie eine gültige BPNA/BPNS ein",
    "placeholder": "BPNA/BPNS auswählen oder eingeben",
    "validBpnWarning": "Hinweis: Die eingegebene BPNA/BPNS wird nicht gegen eine Quelle geprüft, anders als bei der Auswahl aus der Liste. Wenn Sie sie dennoch verwenden möchten, drücken Sie die Eingabetaste.",
    "enterValidBpn": "Geben Sie eine gültige BPNA/BPNS ein (erwartetes Format: BPNA oder BPNS gefolgt von 12 Zeichen)"
  },
  "blockNotifications": {
    "title": "Blocking Notifications",
    "description": "Willkommen bei der benutzerfreundlichen Lösung für den Austausch von Sperrmeldungen zu Bauteilen in Catena-X.",
    "recentNotifications": "Aktuelle Sperrmeldungen",
    "totalAffected": "Betroffene Bauteile gesamt",
    "top5": "Top 5 Austauschpartner",
    "sendNotifications": "Sperrmeldung senden",
    "sendUpdate": "Aktualisierung senden",
    "sentHistory": "Gesendete Sperrmeldungen",
    "receivedHistory": "Empfangene Sperrmeldungen",
    "sendDescription": "Erstellen und senden Sie Sperrmeldungen an Ihre Partner im Catena-X-Netzwerk",
    "learnMore": "Erfahren Sie mehr über Sperrmeldungen",
    "filters": {
      "lastYear": "Letzte 12 Monate",
      "sixMonths": "6 Monate",
      "threeMonths": "3 Monate",
      "oneMonth": "1 Monat",
      "lastWeek": "Letzte Woche",
      "selectDateRange": "Zeitraum auswählen",
      "bpnOrCompany": "Geschäftspartnernummer oder Firmenname"
    },
    "stats": {
      "totalAffectedParts": "Betroffene Bauteile gesamt",
      "topExchangePartners": "Top {count} Austauschpartner",
      "sentNotifications": "Gesendete Sperrmeldungen",
      "receivedNotifications": "Empfangene Sperrmeldungen"
    },
    "sentHistoryDescription": "Gesendete Sperrmeldungen anzeigen und verwalten.",
    "receivedHistoryDescription": "Von Partnern empfangene Sperrmeldungen anzeigen und verwalten.",
    "table": {
      "conversationName": "Vorgang",
      "problemId": "Problem-ID",
      "partner": "Partner",
      "bpn": "BPN",
      "createdAt": "Erstellt am",
      "partnerName": "Partnername",
      "sentBy": "Gesendet von",
      "sentOn": "Gesendet am",
      "receivedOn": "Empfangen am"
    },
    "errors": {
      "fetchSentNotifications": "Gesendete Sperrmeldungen konnten nicht abgerufen werden",
      "fetchStatistics": "Die Statistik konnte nicht geladen werden",
      "fetchRecentNotifications": "Aktuelle Sperrmeldungen konnten nicht geladen werden",
      "invalidDateRange": "Ohne gültigen Zeitraum kann keine Statistik abgerufen werden",
      "sendNotificationFailed": "Die Sperrmeldung konnte nicht gesendet werden.",
      "validationFailed": "Bitte füllen Sie alle Pflichtfelder aus"
    },
    "confirmationText": "Ich bestätige, dass ich alle erforderlichen Angaben korrekt gemacht habe.",
    "validityDisclaimer": "T-Systems prüft die hier eingegebenen Metadaten nicht auf Richtigkeit.",
    "generalInformation": "Allgemeine Informationen",
    "jobName": "Prozessname",
    "jobNamePlaceholder": "Prozessnamen eingeben",
    "receiverBpn": "Empfänger-BPN",
    "expectedResponseBy": "Antwort erwartet bis",
    "success": {
      "notificationSent": "Sperrmeldung erfolgreich gesendet",
      "notificationUpdateSent": "Aktualisierung der Sperrmeldung erfolgreich gesendet"
    },
    "groups": {
      "notificationInformation": "Angaben zur Sperrmeldung",
      "blockInformationItems": "Liste der gesperrten Bauteile *",
      "partIdentification": "Bauteilidentifikation",
      "componentLevelContainment": "Eingrenzung auf Bauteilebene",
      "periodAndVolumeLevelContainment": "Eingrenzung nach Zeitraum und Menge",
      "deliveryInformation": "Lieferinformationen",
      "quantities": "Mengen",
      "sizeOfProductionLot": "Größe des Produktionsloses",
      "numberOfPartsPerDeliveryNote": "Anzahl der Bauteile pro Lieferschein",
      "numberOfPartsPerPackage": "Anzahl der Bauteile pro Packstück",
      "locationInContainer": "Position im Container (optional)"
    },
    "fields": {
      "problemId": "Problem-ID",
      "notificationStatus": "Status der Sperrmeldung",
      "problemDescription": "Problembeschreibung",
      "updateReason": "Grund der Aktualisierung",
      "catenaXId": "Catena-X-ID",
      "blockStatus": "Sperrstatus",
      "manufacturingLocationId": "Produktionsstandort-ID",
      "customerPartId": "Kunden-Teilenummer",
      "integrationLevel": "Integrationsebene",
      "localIdentifiers": "Lokale Kennungen",
      "key": "Schlüssel",
      "value": "Wert",
      "orderNumber": "Bestellnummer",
      "deliveryNoteNumber": "Lieferscheinnummer",
      "packageNumber": "Packstücknummer",
      "deliveryPlace": "Lieferort",
      "productionDate": "Produktionsdatum",
      "deliveryDate": "Lieferdatum",
      "quantity": "Menge",
      "unit": "Einheit",
      "xPosition": "X-Position",
      "yPosition": "Y-Position",
      "smallLoadCarrierLayer": "Lage im kleinen Container"
    },
    "editNotification": "Sperrmeldung bearbeiten",
    "importJson": {
      "title": "JSON-Datei importieren",
      "description": "Laden Sie eine JSON-Datei hoch, um das Formular automatisch mit den enthaltenen Daten zu füllen.",
      "importButton": "Aus JSON importieren",
      "dropFileHere": "Ziehen Sie Ihre JSON-Datei hierher und legen Sie sie dort ab",
      "selectFile": "Datei auswählen",
      "import": "Importieren",
      "success": "Formulardaten erfolgreich aus JSON importiert",
      "parseError": "Die JSON-Datei konnte nicht geparst werden",
      "readError": "Die Datei konnte nicht gelesen werden."
    },
    "partPicker": {
      "button": "Bauteile auswählen",
      "title": "Bauteile auswählen",
      "description": "Wählen Sie digitale Zwillinge aus Ihren bereitgestellten Daten aus, um die gesperrten Bauteile automatisch zu übernehmen.",
      "addToForm": "Zum Formular hinzufügen",
      "success": "{count} Bauteil(e) zum Formular hinzugefügt.",
      "error": "Fehler beim Laden der Aspektdetails. Bitte versuchen Sie es erneut."
    },
    "tooltips": {
      "problemDescription": "Freitext, der beschreibt, warum die Bauteile gesperrt werden müssen.",
      "updateReason": "Freitext, der beschreibt, warum die zuvor übermittelte Liste betroffener Bauteile aktualisiert werden muss.",
      "catenaXId": "Die anonymisierte Catena-X-ID des serialisierten Bauteils oder der Charge.",
      "blockStatus": "Status des einzelnen Bauteils innerhalb einer Sperrmeldung.",
      "manufacturingLocationId": "Standort des Lieferanten, von dem die Bauteile geliefert wurden."
    },
    "updateNotification": "Sperrmeldung aktualisieren",
    "notificationDetails": "Details zur Sperrmeldung",
    "howTo": {
      "description": "Senden und empfangen Sie Sperrmeldungen zu betroffenen Bauteilen und halten Sie Ihre Partner auf dem aktuellen Stand.",
      "doc": "Möchten Sie mehr darüber erfahren, wie Sperrmeldungen funktionieren?"
    }
  },
  "ecu": {
    "title": "Electronic Control Unit (ECU)",
    "description": "Willkommen bei der Übersicht für den Austausch von Steuergeräte-Nachrichten (ECU) im Catena-X-Netzwerk.",
    "sentHistory": "Gesendete Nachrichten",
    "receivedHistory": "Empfangene Nachrichten",
    "sentHistoryDescription": "Ausgehende ECU-Nachrichten an Ihre Partner anzeigen und verwalten.",
    "receivedHistoryDescription": "Eingehende ECU-Nachrichten Ihrer Partner anzeigen und verwalten.",
    "tiles": {
      "item_1": {
        "title": "Ausgehende Nachrichten",
        "description": "Ausgehende ECU-Nachrichten an Partner im Catena-X-Netzwerk anzeigen"
      },
      "item_2": {
        "title": "Eingehende Nachrichten",
        "description": "Eingehende ECU-Nachrichten von Partnern im Catena-X-Netzwerk anzeigen"
      },
      "item_3": {
        "title": "ECU-Dokumentation",
        "description": "Mehr über den ECU-Use-Case und seine Funktionsweise erfahren"
      },
      "item_4": {
        "title": "API-Dokumentation",
        "description": "Schneller Zugriff auf APIs zur Einrichtung und Verwaltung des ECU-Datenaustauschs"
      },
      "item_5": {
        "title": "Datensätze",
        "description": "Alle ECU-Datensätze anzeigen und durchsuchen"
      },
      "item_6": {
        "title": "Logs",
        "description": "Zugriff auf Prozessprotokolle für Transparenz und Störungsmanagement"
      }
    },
    "howTo": {
      "description": "Machen Sie Ihre Lieferkette resilienter: mit automatisierten Statusmeldungen und Rückmeldeschleifen zu elektronischen Steuergeräten im Catena-X-Netzwerk.",
      "doc": "Möchten Sie mehr darüber erfahren, wie die Nachrichtenübermittlung für elektronische Steuergeräte (ECU) funktioniert?"
    },
    "filters": {
      "senderBpn": "Absender-BPN",
      "receiverBpn": "Empfänger-BPN",
      "catenaXId": "Catena-X-ID",
      "ecuId": "ECU-ID",
      "catenaXSiteId": "Catena-X-Standort-ID"
    },
    "table": {
      "conversationName": "Vorgang",
      "senderBpn": "Absender-BPN",
      "receiverBpn": "Empfänger-BPN",
      "sentOn": "Gesendet am",
      "receivedOn": "Empfangen am"
    },
    "errors": {
      "fetchNotifications": "ECU-Benachrichtigungen konnten nicht abgerufen werden"
    },
    "stats": {
      "total": "Gesamt",
      "messagesPerCountry": "Nachrichten pro Land",
      "sentMessages": "Gesendete Nachrichten",
      "receivedMessages": "Empfangene Nachrichten",
      "technicalSpecifications": "Details",
      "connector": "Konnektor",
      "connectors": "Konnektoren",
      "policies": "Policies",
      "viewAllConnectors": "Alle Konnektoren anzeigen",
      "viewAllPolicies": "Alle Policies anzeigen"
    }
  },
  "qualityAlert": {
    "sendSuccess": "Erfolgreich gesendet.",
    "sendAlert": "Qualitätswarnung senden",
    "sendInvestigation": "Qualitätsuntersuchung senden",
    "updateSuccess": "Erfolgreich aktualisiert.",
    "updateAlert": "Qualitätswarnung aktualisieren",
    "updateInvestigation": "Qualitätsuntersuchung aktualisieren",
    "acceptConfirmTitle": "Qualitätswarnung annehmen",
    "acceptConfirmDesc": "Mit Klick auf Ja nehmen Sie diese Qualitätswarnung an und erklären sich bereit, geeignete Maßnahmen zu ergreifen.",
    "rejectConfirmTitle": "Qualitätswarnung ablehnen",
    "rejectConfirmDesc": "Mit Klick auf Ja lehnen Sie diese Qualitätswarnung ab."
  },
  "traceability": {
    "title": "Traceability",
    "description": "Willkommen bei der End-to-End-Traceability-Anwendung für den Datenaustausch in Catena-X",
    "createQualityAlertOrInvestigation": "Qualitätswarnung oder -untersuchung erstellen",
    "learnMore": "Erfahren Sie mehr über Traceability",
    "recentIndustryCoreNotifications": "Aktuelle Industry-Core-Benachrichtigungen",
    "recentTraceabilityNotifications": "Aktuelle Qualitätsmeldungen",
    "tabs": {
      "inbound": "Eingehend",
      "outbound": "Ausgehend",
      "published": "Veröffentlicht",
      "consumed": "Bezogen"
    },
    "howTo": {
      "description": "Durchsuchen Sie den Datenangebotskatalog anderer Catena-X-Teilnehmer.",
      "doc": "Möchten Sie mehr darüber erfahren, wie Vertragsverhandlung und Datenbezug bei Datenangeboten funktionieren?"
    },
    "tiles": {
      "createOffer": {
        "title": "Traceability-Datenangebot erstellen",
        "description": "Stellen Sie Traceability-Daten bereit und teilen Sie sie mit Partnern im Catena-X-Netzwerk"
      },
      "discoverData": {
        "title": "Traceability-Daten finden",
        "description": "Suchen und verhandeln Sie Traceability-Daten im Catena-X-Netzwerk"
      },
      "notifications": {
        "title": "Qualitätsmeldungen",
        "description": "Schneller Zugriff auf Qualitätsmeldungen wie Qualitätswarnungen und Qualitätsuntersuchungen"
      },
      "industryCoreNotifications": {
        "title": "Industry-Core-Benachrichtigungen",
        "description": "Ereignisbenachrichtigungen zu digitalen Zwillingen, z. B. Aktualisierungen von Submodellen, Rückmeldungen und mehr"
      },
      "contractAgreements": {
        "title": "Verträge",
        "description": "Alle bereitgestellten und bezogenen Vertragsvereinbarungen anzeigen"
      },
      "exchangeHistory": {
        "title": "Austauschverlauf",
        "description": "Behalten Sie den Überblick über Ihren Traceability-Datenaustausch im Catena-X-Netzwerk und mit Ihren Partnern",
        "uploadHistory": "Upload-Verlauf",
        "downloadHistory": "Download-Verlauf"
      },
      "blockNotifications": {
        "title": "Sperrmeldungen",
        "description": "Melden Sie Mängel schnell und einfach und senden Sie Sperrmeldungen zu betroffenen Bauteilen an Ihre Partner."
      }
    }
  },
  "useCases": {
    "ecu": {
      "title": "Electronic Control Unit (ECU)",
      "description": "Nachrichtenaustausch zu elektronischen Steuergeräten (ECU) mit Ihren Partnern"
    },
    "ecuTest": {
      "title": "ECU-TEST",
      "description": "ECU-Nachrichtenaustausch ohne Beschränkung auf bestimmte Geschäftspartner (Testumgebung)"
    },
    "co2": {
      "title": "Product Carbon Footprint (PCF)",
      "description": "Austausch von Product Carbon Footprints (CO2-Fußabdruck je Bauteil) entlang der Lieferkette"
    },
    "dcm": {
      "title": "Demand Capacity Management (DCM)",
      "description": "Bedarfe und Kapazitäten mit Ihren Partnern abgleichen: weniger Engpässe, mehr Planungssicherheit"
    },
    "ce": {
      "title": "Circular Economy",
      "description": "Kreislaufwirtschaft: Bauteile und Materialien über den gesamten Lebenszyklus optimal nutzen"
    },
    "companyCertificates": {
      "title": "Company Certificate Management (CCM)",
      "description": "Unternehmenszertifikate (z. B. ISO 9001, IATF 16949) zentral verwalten und mit allen Kunden teilen, statt sie für jeden Kunden einzeln zu pflegen"
    },
    "cyberSecurityKpi": {
      "title": "Cyber Security Metrics (CSM)",
      "description": "Cybersecurity-Kennzahlen standardisiert mit Ihren Kunden teilen, statt sie für jeden Kunden einzeln aufzubereiten"
    },
    "traceability": {
      "title": "Traceability",
      "description": "Bauteile und Materialien über alle Stufen der Lieferkette rückverfolgen, bei voller Datensouveränität"
    },
    "blockingNotifications": {
      "title": "Blocking Notification",
      "description": "Sperrmeldungen zu Bauteilen, die nicht verbaut werden dürfen, digital an Ihre Partner senden"
    },
    "batteryPassBmw": {
      "title": "Batteriepass (BMW)",
      "description": "Batteriepass für die BMW-Lieferkette: Ressourcen in der Batterielieferkette optimal nutzen"
    },
    "modularProduction": {
      "title": "Modular Production",
      "description": "Modulare Produktion: flexible Fertigung über Unternehmensgrenzen hinweg"
    },
    "qualityManagement": {
      "title": "Quality Management",
      "description": "Qualitätsmanagement: Qualitätswarnungen und Untersuchungen mit Partnern austauschen"
    },
    "realTimeControl": {
      "title": "Real Time Control",
      "description": "Echtzeitsteuerung von Produktionsprozessen"
    }
  },
  "certificateUpload": {
    "title": "Zertifikat",
    "pageTitle": "Neues Zertifikat hinzufügen",
    "cardTitle": "Laden Sie Ihr Zertifikat hoch, um zu starten",
    "dragAndDrop": "Ziehen Sie Ihre Zertifikatsdatei hierher",
    "supportedFiles": "Unterstützte Dateitypen: .pdf",
    "invalidFileType": "Nur nicht verschlüsselte PDF-Dateien werden unterstützt.",
    "fileTooLarge": "Die ausgewählte Datei überschreitet die maximal zulässige Dateigröße.",
    "supportedTypesLabel": "Die folgenden Zertifikatstypen werden unterstützt",
    "supportedTypesTooltip": "Weitere Informationen finden Sie in der Dokumentation.",
    "continue": "Weiter",
    "remove": "Entfernen",
    "preview": {
      "title": "Zertifikatsvorschau",
      "subtitle": "Original hochgeladenes Dokument",
      "emptyMessage": "Ihre Zertifikatsvorschau wird hier angezeigt, sobald sie hochgeladen wurde.",
      "emptyTitle": "Laden Sie ein Zertifikat hoch, um es hier anzuzeigen",
      "emptySubtitle": "Laden Sie ein PDF hoch, um es hier anzuzeigen.",
      "fallback": "Die Vorschau ist in diesem Browser nicht verfügbar.",
      "openCertificate": "Zertifikat öffnen",
      "ariaLabel": "Vorschau des hochgeladenen Zertifikats",
      "prevPage": "Vorherige Seite",
      "nextPage": "Nächste Seite"
    },
    "processingMethod": {
      "title": "Verarbeitungsmethode bestätigen",
      "subtitle": "Wählen Sie, wie Sie Zertifikatsinformationen eingeben möchten",
      "fileSummary": "Name beispiel.pdf",
      "proceedWithAi": "Mit KI fortfahren",
      "recommended": "Empfohlen",
      "continueManually": "Manuell fortfahren",
      "proceedWithAiDescLine1": "Unsere KI extrahiert Zertifikatsinformationen automatisch aus Ihrem hochgeladenen Dokument und füllt die Formularfelder vorab aus.",
      "continueManuallyDescLine1": "Sie füllen alle Zertifikatsinformationen manuell ohne KI-Unterstützung aus.",
      "descLine2": "Sie können die Daten vor dem Speichern überprüfen und bearbeiten."
    },
    "aiProcessing": {
      "title": "Zertifikat wird verarbeitet",
      "subtitle": "Unsere KI extrahiert Informationen aus Ihrem Dokument",
      "analyzingTitle": "Ihr Zertifikat wird analysiert...",
      "completedTitle": "Zertifikatsanalyse abgeschlossen",
      "analyzingSubtitle": "Dies kann einige Sekunden dauern",
      "errorSubtitle": "Bitte starten Sie die Analyse erneut",
      "didYouKnow": "Wussten Sie schon?",
      "expirationNotice": "Wir benachrichtigen Sie automatisch, wenn Ihr Zertifikat bald abläuft",
      "shareNotice": "Sie können das gerade hochgeladene Zertifikat gleichzeitig mit mehreren Partnern teilen",
      "errorMessage": "Wir konnten Ihr Zertifikat nicht analysieren. Bitte versuchen Sie es erneut.",
      "retry": "Erneut versuchen",
      "errors": {
        "extractionFailed": "Wir konnten Ihr Zertifikat nicht analysieren. Bitte versuchen Sie es erneut.",
        "noFile": "Es wurde keine gültige Datei übermittelt. Bitte laden Sie eine unterstützte Zertifikatsdatei hoch und versuchen Sie es erneut.",
        "unsupportedFileType": "Nicht unterstützter Dateityp. Bitte laden Sie eine PDF-, JPEG- oder PNG-Zertifikatsdatei hoch.",
        "invalidImage": "Das hochgeladene Bild konnte nicht verarbeitet werden. Bitte laden Sie ein klares und unterstütztes Bild hoch.",
        "imageDimensionsExceeded": "Das hochgeladene Bild ist zu groß. Bitte verwenden Sie ein Bild mit kleineren Abmessungen.",
        "fileSizeExceeded": "Die hochgeladene Datei ist zu groß. Bitte wählen Sie eine kleinere Zertifikatsdatei aus.",
        "notCompanyCertificate": "Das hochgeladene Dokument wird nicht als Unternehmenszertifikat erkannt. Bitte laden Sie ein gültiges Unternehmenszertifikat hoch.",
        "invalidCertificateType": "Der Zertifikatstyp in diesem Dokument wird nicht unterstützt.",
        "certificateTextTooLong": "Der Zertifikatstext ist zu lang für die Verarbeitung. Bitte laden Sie ein kürzeres oder bereinigtes Dokument hoch.",
        "processingTimeout": "Die Dokumentverarbeitung hat das Zeitlimit überschritten. Bitte versuchen Sie es erneut.",
        "processingInterrupted": "Die Dokumentverarbeitung wurde unterbrochen. Bitte versuchen Sie es erneut.",
        "noDataExtracted": "Aus diesem Dokument konnten keine Zertifikatsdaten extrahiert werden.",
        "batchExtractionFailed": "Die Zertifikatsextraktion ist bei der Seitenverarbeitung fehlgeschlagen. Bitte versuchen Sie es erneut.",
        "aiResponseTruncated": "Die Antwort des Extraktionsdienstes wurde abgeschnitten. Bitte versuchen Sie es später erneut.",
        "processingFailed": "Das Zertifikat konnte nicht verarbeitet werden. Bitte versuchen Sie es erneut.",
        "pdfUnsupported": "Diese PDF enthält nicht unterstützte Inhalte oder Strukturen. Bitte laden Sie eine andere PDF hoch.",
        "llmUnavailable": "Der KI-Dienst ist derzeit ausgelastet. Bitte versuchen Sie es in Kürze erneut.",
        "auth": "Sie sind für die Zertifikatsextraktion nicht berechtigt. Bitte melden Sie sich erneut an.",
        "unavailable": "Die Zertifikatsextraktion ist derzeit nicht verfügbar.",
        "rateLimit": "Zu viele Extraktionsanfragen. Bitte versuchen Sie es später erneut.",
        "fileReadFailed": "Die hochgeladene Datei konnte nicht gelesen werden. Bitte laden Sie die Datei erneut hoch und versuchen Sie es erneut.",
        "serverError": "Bei der Zertifikatsextraktion ist ein Serverfehler aufgetreten. Bitte versuchen Sie es später erneut.",
        "connectionTimeout": "Die Anfrage hat zu lange gedauert und die Verbindung wurde getrennt. Bitte versuchen Sie es erneut. Große Dokumente können einige Minuten Verarbeitungszeit benötigen."
      },
      "processingProgress": "Verarbeitung... {percent}% abgeschlossen",
      "steps": {
        "validating": "Dokument wird validiert",
        "preparing": "Dokument wird vorbereitet",
        "extractingText": "Textinhalt wird extrahiert",
        "convertingImages": "Seiten werden in Bilder umgewandelt",
        "waitingLlm": "Warten auf KI-Antwort",
        "analyzing": "Zertifikat wird analysiert",
        "batchProgress": "Seitengruppe {done} von {total}",
        "merging": "Ergebnisse werden zusammengeführt"
      }
    },
    "review": {
      "title": "Zertifikatsdetails",
      "subtitle": "Prüfen Sie alle unten vorausgefüllten Daten",
      "successMessage": "Zertifikatsdaten erfolgreich extrahiert. Bitte prüfen und bearbeiten Sie sie bei Bedarf.",
      "certificateName": "Zertifikatsname",
      "issuer": "Aussteller",
      "certificateId": "Zertifikats-ID",
      "ownerOrganization": "Eigentümerorganisation",
      "validFrom": "Gültig ab",
      "validUntil": "Gültig bis",
      "scope": "Geltungsbereich",
      "confirmation": "Ich bestätige, dass die eingegebenen Daten korrekt sind.",
      "back": "Zurück",
      "save": "Zertifikat speichern",
      "previewTitle": "Zertifikatsvorschau",
      "previewSubtitle": "Original hochgeladenes Dokument",
      "enclosedSitesSubtitle": "Wählen Sie die BPNA/BPNS-Standorte aus, die durch dieses Zertifikat abgedeckt sind.",
      "aiConfirmation": "Ich erkenne an, dass für die per KI vorausgefüllten Daten keine Haftung übernommen wird, und bestätige, dass ich diese geprüft habe.",
      "aiNotice": "Die folgenden Inhalte wurden mithilfe von KI vorausgefüllt. KI kann Fehler machen. Bitte prüfen Sie die Daten auf Richtigkeit.",
      "metadataConfirmation": "Ich bestätige, dass ich alle erforderlichen Angaben korrekt gemacht habe, und erkenne an, dass T-Systems bei fehlerhaften Angaben und einer daraus folgenden Ablehnung des Angebots nicht haftet.",
      "metadataNotice": "T-Systems prüft die hier eingegebenen Metadaten nicht auf Richtigkeit. Bitte stellen Sie sicher, dass Ihre Angaben korrekt und vollständig sind."
    }
  },
  "backendUnavailable": {
    "title": "Dienst vorübergehend nicht verfügbar",
    "subtitle": "Der Backend-Dienst ist derzeit nicht erreichbar. Bitte überprüfen Sie Ihre Verbindung oder versuchen Sie es später erneut.",
    "retryButton": "Erneut versuchen",
    "checking": "Verbindung wird überprüft..."
  }
}
